const et = {
  // Navigation
  nav: {
    features: 'Funktsioonid',
    useCases: 'Kasutusjuhud',
    pricing: 'Hinnakiri',
    blog: 'Blogi',
    about: 'Meist',
    consulting: 'Konsultatsioon',
    login: 'Logi sisse',
    startFree: 'Alusta tasuta →',
    dashboard: 'Töölaud',
    teams: 'Meeskonnad',
    sprints: 'Sprindid',
    kpis: 'KPI-d',
    users: 'Kasutajad',
    profileSettings: 'Profiili seaded',
    companySettings: 'Ettevõtte seaded',
    subscription: 'Tellimus',
    superAdminPanel: 'SuperAdmin paneel',
    logout: 'Logi välja',
  },

  // Use cases dropdown
  useCases: {
    smallStartups: 'Väikeettevõtted (1-20)',
    smb: 'Keskmised ettevõtted (21-200)',
    enterprise: 'Suurettevõtted',
    itTeams: 'IT meeskonnad',
    operations: 'Operatsioonid',
    sales: 'Müük',
    managementBoard: 'Juhatus',
    projectManagement: 'Projektijuhtimine',
    publicInstitutions: 'Avalik sektor',
    nonprofits: 'Mittetulundusühingud',
    hrTeams: 'Personaliosakond',
    manufacturing: 'Tootmine',
  },

  // Landing page
  landing: {
    badge: 'Jälgi KPI-sid alla 60 sekundiga',
    heroTitle1: 'Sinu ettevõtte tulemuslikkus,',
    heroTitle2: 'Visualiseeritud',
    heroDescription: 'Kaasaegne viis juhtidele ja meeskondadele KPI-de jälgimiseks, sprintide planeerimiseks ja kõigi tiimiliikmete ühele lehele saamiseks.',
    getStarted: 'Alusta tasuta',
    viewDemo: 'Vaata demo',
    featuresTitle: 'Kõik, mida vajad tulemuslikkuse jälgimiseks',
    featuresSubtitle: 'Loodud kaasaegsetele ettevõtetele, kes soovivad jälgida ja juhtida ettevõtte tulemusi läbipaistvalt',
    fromBlog: 'Meie blogist',
    blogTitle: 'Ekspertide nõuanded KPI\'de juhtimiseks',
    blogSubtitle: 'Õpi tõestatud strateegiaid tõhusate KPI süsteemide loomiseks ja tulemuslikkuse tõstmiseks.',
    readArticle: 'Loe artiklit',
    viewAllArticles: 'Vaata kõiki artikleid',
    ctaTitle: 'Valmis oma tulemuslikkust selgelt juhtima?',
    ctaSubtitle: 'Alusta kohe! Kasuta Outsprinterit, et püsida rajal ja kasvatada oma äri',
    startTrial: 'Alusta tasuta prooviperioodi',
  },

  // Features
  features: {
    kpiManagement: 'KPI haldus',
    kpiManagementDesc: 'Defineeri, jälgi ja visualiseeri peamisi tulemusnäitajaid kogu organisatsioonis.',
    realtimeDashboards: 'Reaalajas töölauad',
    realtimeDashboardsDesc: 'Ilusad graafikud, mis uuenevad koheselt, kui meeskonnad sisestavad nädalasi andmeid.',
    sprintPlanning: 'Sprindi planeerimine',
    sprintPlanningDesc: 'Planeeri ja halda meeskonna sprinte ülesannete, tähtaegade ja edenemise jälgimisega.',
    recurringSprintsTitle: 'Korduvad sprindid',
    recurringSprintsDesc: 'Loo automaatselt iganädalased või kahenädalased sprindid järjepideva täitmisrütmi säilitamiseks.',
    sprintRetroTitle: 'Sprindi retrospektiivid',
    sprintRetroDesc: 'Dokumenteeri õppetunnid, jäädvusta mis läks hästi ja jälgi tegevuspunkte pärast iga sprinti.',
    roleBasedAccess: 'Rollipõhine ligipääs',
    roleBasedAccessDesc: 'Juhid näevad kõike, meeskonnajuhid keskenduvad oma meeskondadele, vaatajad jälgivad.',
    aiAssistant: 'AI assistent',
    aiAssistantDesc: 'Vestle, et planeerida paremaid KPI-sid, sprindi ülesandeid ja saada ülevaated meeskonna tulemuslikkusest.',
    trendAnalysis: 'Trendide analüüs',
    trendAnalysisDesc: 'Jälgi edenemist ajas iganädalaste trendide ja tulemuslikkuse prognoosidega.',
    enterpriseSecurity: 'Ettevõtte turvalisus',
    enterpriseSecurityDesc: 'Andmed krüpteeritud, GDPR vastavus ja täielik andmete eraldatus.',
  },

  // Footer
  footer: {
    description: 'Kaasaegne viis juhtidele ja meeskondadele KPI-de jälgimiseks, riskide varajaseks tuvastamiseks ja kõigi ühele lehele saamiseks.',
    product: 'Toode',
    useCases: 'Kasutusjuhud',
    resources: 'Ressursid',
    company: 'Ettevõte',
    legal: 'Juriidiline',
    features: 'Funktsioonid',
    pricing: 'Hinnakiri',
    updates: 'Uuendused',
    blog: 'Blogi',
    helpCenter: 'Abikeskus',
    faq: 'KKK',
    aboutUs: 'Meist',
    consultingAdvisory: 'Konsultatsioon ja nõustamine',
    contact: 'Kontakt',
    press: 'Press',
    affiliates: 'Partnerid',
    termsOfService: 'Teenuse tingimused',
    privacyNotice: 'Privaatsusteade',
    cookiePolicy: 'Küpsiste poliitika',
    copyright: '© 2026 Outsprinter. Kõik õigused kaitstud.',
    uptime: '99.9% tööaeg',
  },

  // Pricing page
  pricing: {
    tryFree: 'Proovi tasuta 14 päeva',
    manageSubscription: 'Halda oma tellimust',
    chooseYourPlan: 'Vali oma plaan',
    yourSubscription: 'Sinu tellimus',
    subscribedSubtitle: 'Sul on aktiivne tellimus. Uuenda või halda oma plaani allpool.',
    unsubscribedSubtitle: 'Kõik plaanid sisaldavad Outsprinteri täisfunktsionaalsust. Vali vastavalt meeskonna suurusele.',
    monthly: 'Kuumakse',
    yearly: 'Aastamakse',
    save30: 'Säästa 30% võrreldes kuumaksega',
    month: 'kuu',
    year: 'aasta',
    planLimits: 'Plaani piirangud',
    allFeaturesIncluded: 'Kõik funktsioonid kaasas',
    bestFor: '🎯 Sobib:',
    startFree: 'Alusta tasuta',
    currentPlan: 'Praegune plaan',
    switchPlan: 'Vaheta plaani',
    subscribeNow: 'Telli kohe',
    processing: 'Töötlemisel...',
    yourPlan: 'Sinu plaan',
    popular: 'Populaarne',
    enterpriseLine: 'Vajad rohkem kui 75 kasutajat, SSO-d või API ligipääsu?',
    contactUs: 'Võta ühendust',
    forEnterprise: 'ettevõtte hinnapakkumise saamiseks.',
    needHelp: 'Vajad abi? Võta ühendust meie tugitiimiga.',
    allPlansInclude: 'Kõik plaanid sisaldavad 14-päevast tasuta prooviperioodi. Krediitkaart pole vajalik.',
    redirecting: 'Suunamine makselehele',
    redirectingDesc: 'Sind suunatakse tellimuse lõpetamiseks.',
    checkoutError: 'Makse alustamine ebaõnnestus. Palun proovi uuesti.',
    starter: 'STARTER',
    starterDesc: 'Väikestele meeskondadele alustamiseks',
    professional: 'PROFESSIONAL',
    professionalDesc: 'Kasvavatele ettevõtetele',
    business: 'BUSINESS',
    businessDesc: 'Suuremate organisatsioonide jaoks',
    teams3: '3 meeskonda',
    kpis20: '20 KPI-d',
    users5: '5 kasutajat',
    teams10: '10 meeskonda',
    kpis75: '75 KPI-d',
    users25: '25 kasutajat',
    teamsUnlimited: 'Piiramatu arv meeskondi',
    kpisUnlimited: 'Piiramatu arv KPI-sid',
    users75: '75 kasutajat',
    smallBusinesses: 'Väikeettevõtted',
    agencies: 'Agentuurid',
    employees520: '5–20 töötajat',
    scalingStartups: 'Kasvavad idufirmad',
    employees20100: '20–100 töötajat',
    multiDepartment: 'Mitme osakonnaga',
    employees100: '100+ töötajat',
    leadershipTeams: 'Juhtkonnad',
    investorReporting: 'Investorite aruandlus',
    weeklyKpiTracking: 'Iganädalane KPI jälgimine',
    dashboardCharts: 'Töölaud graafikute ja diagrammidega',
    fullKpiTree: 'Täielik KPI puu vaade',
    autoStatusLogic: 'Automaatne staatuse loogika',
    goalPlanner: 'Eesmärkide planeerija (sihtmärgid)',
    historicalData: 'Ajaloolised andmed ja trendid',
    sprintPlanning: 'Sprindi planeerimine ja jälgimine',
    taskAssignments: 'Ülesannete määramine',
    recurringSprintsFeature: 'Korduvad sprindid',
    taskCarryOver: 'Ülesannete ülekandmine',
    sprintRetrospectives: 'Sprindi retrospektiivid',
    sprintAnalytics: 'Sprindi analüütika',
    teamStructure: 'Meeskonna struktuur (org skeem)',
    roleBasedAccessControl: 'Rollipõhine ligipääsu kontroll',
    csvExport: 'CSV eksport',
    departmentPerformance: 'Osakonna tulemuslikkuse vaade',
    aiAssistantPlanning: 'AI assistent planeerimiseks',
    emailSupport: 'E-posti tugi',
  },

  // About page
  about: {
    title: 'Outsprinterist',
    heroDescription: 'Outsprinter on tulemuslikkuse juhtimise platvorm, mis on loodud juhtidele, kes soovivad',
    realClarity: 'tõelist selgust',
    realAccountability: 'tõelist vastutust',
    realResults: 'tõelisi tulemusi',
    missionIntro: 'Lõime Outsprinteri, et lahendada probleem, mis esineb peaaegu igas ettevõttes: eesmärgid on seatud, kuid edenemine on ebaselge, killustatud ja sageli põhineb kõhutundel, mitte tegelikel andmetel.',
    missionTitle: 'Meie missioon on lihtne —',
    missionDesc: 'aidata ettevõtetel hallata oma tulemuslikkust läbipaistval, andmepõhisel ja järjepideval viisil, nii et iga meeskond teab:',
    missionPoint1: 'mis on oluline,',
    missionPoint2: 'kuidas neil läheb,',
    missionPoint3: 'ja mis vajab kohe tähelepanu.',
    executionRhythm: 'Outsprinter muudab strateegia iganädalaseks täitmisrütmiks.',
    replacesExcel: 'See asendab laiali paisatud Exceli failid, unustatud KPI-d ja hägustunud vastutuse:',
    kpiTree: 'visuaalse KPI puuga,',
    weeklyTracking: 'iganädalase jälgimisega,',
    autoStatus: 'automaatse staatuse loogikaga,',
    clearDashboards: 'ja selgete töölaudadega juhtidele ja meeskondadele.',
    resultStatement: 'Tulemus ei ole lihtsalt parem aruandlus — vaid tugevam fookus, kiiremad otsused ja mõõdetavad tulemused.',
    whyTitle: 'Miks Outsprinter loodi',
    whyIntro: 'Outsprinter ei sündinud teooriast ega konsultatsiooni raamistikest. See sündis',
    realExperience: 'tegelikust juhtimiskogemusest',
    whyIntroEnd: 'kasvavates ettevõtetes.',
    founderExperience: 'Asutaja ja tegevjuhina kogesin ise, kui kiiresti organisatsioonid kaotavad fookuse, kui:',
    whyPoint1: 'andmed elavad erinevates tööriistades,',
    whyPoint2: 'KPI-sid jälgitakse ebaregulaarselt,',
    whyPoint3: 'meeskonnad ei näe suurt pilti,',
    whyPoint4: 'ja juhtkond reageerib liiga hilja.',
    solutionNotMeetings: 'Lahendus polnud rohkem koosolekuid.',
    solutionWas: 'Lahendus oli',
    simpleVisual: 'lihtne, visuaalne ja distsiplineeritud tulemuslikkuse süsteem',
    thatForces: 'mis sunnib:',
    weeklyReflection: 'iganädalasele peegeldamisele,',
    honestNumbers: 'ausatele numbritele,',
    clearOwnership: 'ja selgele vastutusele.',
    builtToEnsure: 'Outsprinter loodi tagamaks, et:',
    ensurePoint1: 'strateegia ei jää slaididele,',
    ensurePoint2: 'eesmärgid ei sure tabelitesse,',
    ensurePoint3: 'ja täitmine saab osaks ettevõtte iganädalasest südamelöögist.',
    founder: 'Asutaja',
    connectLinkedIn: 'Ühenda LinkedInis',
    founderBio: 'Arti Kütt on ettevõtja, kes on loonud idufirmasid, juhtinud rahvusvahelisi tehnoloogia- ja e-kaubanduse ettevõtteid ning investeerib aktiivselt kohaliku äriinglina. Tema töö keskendub skaleeritavate ettevõtete loomisele selge täitmise ja mõõdetavate tulemustega.',
    philosophyTitle: 'Meie filosoofia',
    belief1: 'Mida mõõdetakse iganädalaselt, seda parandatakse.',
    belief2: 'Mis on läbipaistev, selle eest võetakse vastutus.',
    belief3: 'Mis on visuaalne, saab mõistetud.',
    belief4: 'Mida jälgitakse järjekindlalt, annab tulemusi.',
    philosophyStatement: 'Me ehitame Outsprinterit asutajatele, tegevjuhtidele ja juhtmeeskondadele, kes ei taha vabandusi, kaost ega hilinenud reaktsioone — vaid tahavad',
    controlClarityResults: 'kontrolli, selgust ja tulemusi',
    visionTitle: 'Meie visioon',
    visionStatement: 'Saada kõige lihtsamaks ja usaldusväärsemaks tulemuslikkuse juhtimissüsteemiks juhtmeeskondadele üle Euroopa ja kaugemal — kus',
    strategyExecution: 'strateegia, täitmine ja vastutus',
    liveInOnePlace: 'elavad ühes kohas.',
  },

  // Auth page
  auth: {
    welcomeBack: 'Tere tulemast tagasi',
    createAccount: 'Loo oma konto',
    loginDesc: 'Sisesta oma andmed, et pääseda töölaudale',
    signupDesc: 'Alusta Outsprinteriga sekunditega',
    inviteDesc: 'Lõpeta oma konto seadistamine, et liituda meeskonnaga',
    continueWithGoogle: 'Jätka Google\'iga',
    orContinueWith: 'Või jätka',
    fullName: 'Täisnimi',
    email: 'E-post',
    password: 'Parool',
    agreeToTerms: 'Nõustun',
    termsOfService: 'Teenuse tingimustega',
    and: 'ja',
    privacyPolicy: 'Privaatsuspoliitikaga',
    forgotPassword: 'Unustasid parooli?',
    signIn: 'Logi sisse',
    signingIn: 'Sisselogimine...',
    createAccountBtn: 'Loo konto',
    creatingAccount: 'Konto loomine...',
    noAccount: 'Pole kontot?',
    haveAccount: 'On juba konto?',
    signUp: 'Registreeru',
    resetPassword: 'Lähtesta parool',
    resetDesc: 'Sisesta oma e-posti aadress ja saadame sulle parooli lähtestamise lingi.',
    resetSent: 'Kontrolli oma e-posti parooli lähtestamise lingi saamiseks.',
    resetSentTo: 'Saatsime parooli lähtestamise lingi aadressile',
    checkSpam: 'Ei saanud? Kontrolli rämpsposti kausta või proovi uuesti.',
    tryDifferentEmail: 'Proovi teist e-posti',
    done: 'Valmis',
    emailAddress: 'E-posti aadress',
    sendResetLink: 'Saada lähtestamise link',
    sendingReset: 'Saatmine...',
  },

  // Contact page
  contact: {
    title: 'Võta ühendust Outsprinteriga',
    subtitle: 'Oleme siin, et aidata sul paremini täita.',
    description: 'Olenemata sellest, kas hindad Outsprinterit, vajad tuge või soovid uurida, kuidas see sinu organisatsiooniga sobib, meie meeskond on valmis aitama.',
    getInTouch: '📩 Võta ühendust',
    formIntro: 'Kasuta kontaktvormi, et pöörduda meie poole seoses:',
    productQuestions: 'Toote küsimused',
    salesInquiries: 'Müügipäringud',
    enterprisePricing: 'Ettevõtte hinnakiri',
    onboardingTraining: 'Juurutamine ja koolitus',
    supportRequests: 'Tugipäringud',
    partnerships: 'Partnerlused',
    name: 'Nimi',
    yourName: 'Sinu nimi',
    email: 'E-post',
    yourEmail: 'sinu@email.ee',
    company: 'Ettevõte',
    yourCompany: 'Sinu ettevõte',
    message: 'Sõnum',
    howCanWeHelp: 'Kuidas saame aidata?',
    sendMessage: 'Saada sõnum',
    responseTime: 'Tavaliselt vastame ühe tööpäeva jooksul.',
    salesDemos: '🧭 Müük ja demod',
    salesDesc: 'Soovid näha Outsprinterit tegevuses või arutada hinnakiri?',
    bookDemo: 'Broneeri demo',
    bookLiveDemo: 'Broneeri live demo',
    requestEnterprise: 'Küsi ettevõtte hinnakiri',
    customerSupport: '🛠️ Klienditugi',
    supportDesc: 'Oled juba klient ja vajad abi?',
    inAppSupport: 'Rakendusesisene tugi',
    emailSupportLabel: 'E-posti tugi',
    helpCenterResources: 'Abikeskuse ressursid',
    visitHelpCenter: 'Külasta abikeskust',
    generalInquiries: '📧 Üldised päringud',
    generalDesc: 'Partnerluste, meedia või üldiste küsimuste korral:',
    responseWithin24h: 'Vastamisaeg: 24 tunni jooksul',
    ourApproach: '🌍 Meie lähenemine',
    supportShouldBe: 'Usume, et tugi peaks olema:',
    fast: 'Kiire',
    clear: 'Selge',
    human: 'Inimlik',
    focusedOnOutcomes: 'Tulemustele suunatud',
    noTicketBlackHoles: 'Ei mingeid piletimusti auke. Ei mingit tarbetut edasi-tagasi suhtlust.',
    letsTalk: '📣 Räägime täitmisest.',
    contactUsBtn: 'Võta ühendust',
  },

  // FAQ page
  faq: {
    title: 'Korduma kippuvad küsimused',
    subtitle: 'Selged vastused levinud küsimustele Outsprinteri kohta.',
    stillHaveQuestions: '📣 Veel küsimusi? Oleme siin, et aidata.',
    contactSupport: 'Võta ühendust tugiga',
    bookDemo: 'Broneeri demo',
    productFunctionality: '🧠 Toode ja funktsionaalsus',
    kpisSprints: '📊 KPI-d ja sprindid',
    aiAssistant: '🧠 AI assistent',
    usersAccounts: '👥 Kasutajad ja kontod',
    pricingBilling: '💳 Hinnakiri ja arveldus',
    securityPrivacy: '🔐 Turvalisus ja privaatsus',
    support: '🛠️ Tugi',
    whatIsOutsprinter: 'Mis on Outsprinter?',
    whatIsOutsprinterA: 'Outsprinter on B2B täitmisplatvorm, mis aitab ettevõtetel seada KPI-sid, planeerida iganädalasi sprinte, jälgida täitmist ja saada AI-põhiseid ülevaateid — kõik ühes kohas.',
    isProjectMgmt: 'Kas Outsprinter on projektijuhtimise tööriist?',
    isProjectMgmtA: 'Ei. Outsprinter keskendub täitmisele, tulemustele ja KPI-dele. See täiendab projektitööriistu nagu Jira või Asana, mitte ei asenda neid.',
    whatMakesDifferent: 'Mis teeb Outsprinteri erinevaks?',
    whatMakesDifferentA: 'Outsprinter ühendab strateegia, KPI-d, iganädalase rütmi, sprindid ja AI ülevaated üheks täitmise operatsioonisüsteemiks.',
    howOftenUpdate: 'Kui tihti tuleks KPI-sid uuendada?',
    howOftenUpdateA: 'Outsprinter on üles ehitatud iganädalasele rütmile. Iganädalased uuendused annavad kiire tagasiside ja parema täitmisdistsipliini.',
    howManyKpis: 'Mitu KPI-d peaksime jälgima?',
    howManyKpisA: 'Enamik meeskondi toimib kõige paremini 3–7 KPI-ga meeskonna või osakonna kohta.',
    canKpisRollUp: 'Kas KPI-d koonduvad ettevõtte tasandi eesmärkideks?',
    canKpisRollUpA: 'Jah. KPI puu struktuur võimaldab täielikku koondvaate.',
    whatDoesAiDo: 'Mida AI assistent teeb?',
    whatDoesAiDoA: 'AI assistent analüüsib KPI-sid ja sprinte, tuvastab riske, genereerib kokkuvõtteid ja soovitab parandusi.',
    doesAiDecide: 'Kas AI teeb otsuseid automaatselt?',
    doesAiDecideA: 'Ei. AI annab ülevaateid ja soovitusi — inimesed jäävad kontrolli juurde.',
    isDataUsedForAi: 'Kas meie andmeid kasutatakse avalike AI mudelite treenimiseks?',
    isDataUsedForAiA: 'Ei. Klientide andmed on eraldatud ja neid ei kasutata kunagi avalike mudelite treenimiseks.',
    canInviteExternal: 'Kas saame kutsuda väliseid kasutajaid?',
    canInviteExternalA: 'Jah, administraatorid saavad kasutajaid kutsuda ja rolle määrata.',
    multipleCompanies: 'Kas kasutajad saavad kuuluda mitmesse ettevõttesse?',
    multipleCompaniesA: 'Iga kasutaja kuulub korraga ühte ettevõttesse andmete eraldatuse ja turvalisuse tagamiseks.',
    roleBasedSupported: 'Kas rollipõhine ligipääs on toetatud?',
    roleBasedSupportedA: 'Jah. Outsprinter toetab administraatori, halduri, kasutaja ja vaataja rolle.',
    isFreeTrial: 'Kas on tasuta prooviperiood?',
    isFreeTrialA: 'Jah. Outsprinter pakub tasuta prooviperioodi põhifunktsioonidega.',
    canChangePlans: 'Kas saame plaani hiljem muuta?',
    canChangePlansA: 'Jah. Plaane saab igal ajal uuendada või alandada.',
    nonprofitDiscounts: 'Kas pakute mittetulundusühingutele allahindlusi?',
    nonprofitDiscountsA: 'Jah. Kinnitatud mittetulundusühingud saavad soodushinnaga.',
    isGdpr: 'Kas Outsprinter vastab GDPR nõuetele?',
    isGdprA: 'Jah. Outsprinter on loodud GDPR põhimõtteid silmas pidades.',
    whereDataStored: 'Kus andmeid hoitakse?',
    whereDataStoredA: 'Andmeid hoitakse turvaliselt pilveinfrastruktuuris krüpteerimisega nii salvestamisel kui edastamisel.',
    canExportDelete: 'Kas saame oma andmeid eksportida või kustutada?',
    canExportDeleteA: 'Jah. Administraatorid saavad andmeid eksportida ja taotleda täielikku kustutamist.',
    whatSupportOptions: 'Millised tugivalikud on saadaval?',
    whatSupportOptionsA: 'E-posti tugi, rakendusesisene abi, juurutamise sessioonid ja ettevõtte tugivõimalused.',
    offerOnboarding: 'Kas pakute juurutamist?',
    offerOnboardingA: 'Jah. Juhendatud juurutamine on saadaval meeskondadele ja ettevõtetele.',
  },

  // Help Center page
  helpCenter: {
    title: 'Abikeskus',
    subtitle: 'Kõik, mida vajad Outsprinterist väärtuse saamiseks — kiiresti.',
    description: 'Olenemata sellest, kas oled tegevjuht, meeskonnajuht või meeskonnaliige, leiad siit selge juhendamise, samm-sammult juhised ja praktilised näited.',
    structureTitle: '🔍 Kuidas abikeskus on üles ehitatud',
    needMoreHelp: '📣 Vajad rohkem abi?',
    cantFind: 'Kui ei leia otsitut:',
    contactFromApp: 'Võta tugitiimiga ühendust otse rakendusest',
    emailSupport: 'Saada meile e-kiri',
    bookOnboarding: 'Broneeri juhendatud juurutamise sessioon',
    contactSupportBtn: 'Võta ühendust tugiga',
    bookOnboardingBtn: 'Broneeri juurutamise sessioon',
    gettingStartedTitle: 'Alustamine',
    gettingStartedDesc: 'Ideaalne uutele kasutajatele ja meeskondadele.',
    kpiGuidesTitle: 'KPI halduri juhendid',
    kpiGuidesDesc: 'Õpi, kuidas kujundada ja jälgida tähendusrikkaid KPI-sid.',
    sprintManagerTitle: 'Meeskonna sprindi haldur',
    sprintManagerDesc: 'Omanda iganädalane täitmine ja sprindi planeerimine.',
    aiAssistantTitle: 'Nutikas AI assistent',
    aiAssistantDesc: 'Saa AI-põhistest ülevaadetest maksimum.',
    dashboardsTitle: 'Töölauad ja aruandlus',
    dashboardsDesc: 'Õpi töölaudu tõlgendama ja kasutama.',
    userCompanyMgmtTitle: 'Kasutajate ja ettevõtte haldus',
    userCompanyMgmtDesc: 'Administraatoritasandi seadistamine ja kontroll.',
    securityTitle: 'Turvalisus, privaatsus ja vastavus',
    securityDesc: 'Mõista, kuidas Outsprinter sinu andmeid kaitseb.',
    troubleshootingTitle: 'Veaotsing ja tugi',
    troubleshootingDesc: 'Kiired vastused levinud probleemidele.',
    // Topics
    gs1: 'Konto ja ettevõtte loomine',
    gs2: 'Kasutajate kutsumine ja rollide määramine',
    gs3: 'Esimeste KPI-de seadistamine',
    gs4: 'KPI puu mõistmine',
    gs5: 'Esimese iganädalase sprindi planeerimine',
    kpi1: 'Kuidas defineerida tõhusaid KPI-sid',
    kpi2: 'Ettevõtte vs osakonna KPI-d',
    kpi3: 'Iganädalase KPI uuendamise parimad tavad',
    kpi4: 'KPI künnised (roheline / kollane / punane)',
    kpi5: 'KPI omandiõigus ja vastutus',
    kpi6: 'KPI trendid ja prognoosimine',
    sp1: 'Kuidas planeerida iganädalasi sprinte',
    sp2: 'Sprindi prioriteetide valimine',
    sp3: 'Sprindi ülevaated ja retrospektiivid',
    sp4: 'Ülekoormatuse vältimine',
    sp5: 'Sprindi edukuse mõõtmine',
    ai1: 'Kuidas AI genereerib ülevaateid',
    ai2: 'AI soovitatud KPI-d ja sprindid',
    ai3: 'AI riskihoiatuste mõistmine',
    ai4: 'AI kokkuvõtted ja aruanded',
    ai5: 'Kuidas AI aja jooksul paraneb',
    dash1: 'Ettevõtteülesed töölauad',
    dash2: 'Meeskonna töölauad',
    dash3: 'Juhatuse tasandi vaated',
    dash4: 'Prognoos ja trendianalüüs',
    dash5: 'Aruannete eksportimine (PDF, CSV)',
    ucm1: 'Kasutajate ja rollide haldamine',
    ucm2: 'Ettevõtte profiili seaded',
    ucm3: 'Õigused ja ligipääsu kontroll',
    ucm4: 'Arvelduse ja tellimuse haldus',
    ucm5: 'Auditilogi',
    sec1: 'Andmeturbe ülevaade',
    sec2: 'GDPR vastavus',
    sec3: 'Ligipääsu logimine ja auditijäljed',
    sec4: 'Andmete eksport ja kustutamine',
    ts1: 'Sisselogimise ja ligipääsu probleemid',
    ts2: 'KPI uuendamise probleemid',
    ts3: 'Sprindi nähtavuse probleemid',
    ts4: 'Teavituste veaotsing',
  },

  // Use case shared
  useCaseCta: {
    startFreeTrial: 'Alusta tasuta prooviperioodi →',
    bookDemo: 'Broneeri demo',
  },

  // Terms of Service
  terms: {
    title: 'Teenuse tingimused',
    effectiveDate: 'Jõustumiskuupäev',
    intro: 'Tere tulemast Outsprinterisse. Need teenuse tingimused ("Tingimused") reguleerivad teie juurdepääsu Outsprinteri platvormile, veebisaidile ja teenustele ("Teenus") ning nende kasutamist.',
    agreement: 'Konto loomisel või teenuse kasutamisel nõustute nende tingimustega.',
    s1Title: '1. Mõisted',
    s1d1: 'viitab ettevõttele, mis opereerib Outsprinteri platvormi.',
    s1d2: 'viitab isikule või üksusele, kes kasutab teenust.',
    s1d3: 'tähendab registreeritud kasutajakontot.',
    s1d4: 'tähendab Outsprinteris loodud organisatsiooni.',
    s1d5: 'tähendab kõiki andmeid, KPI-sid, teksti ja teavet, mis on teenusesse sisestatud.',
    s2Title: '2. Teenuse kasutamine',
    s2p1: 'Te võite teenust kasutada ainult kooskõlas nende tingimuste ja kehtivate seadustega.',
    s2agree: 'Te nõustute',
    s2a1: 'Esitama täpset kontoteavet',
    s2a2: 'Hoidma oma sisselogimisandmeid turvalisena',
    s2a3: 'Kasutama teenust ainult seaduslikel ärilistel eesmärkidel',
    s2mustNot: 'Te ei tohi',
    s2n1: 'Pääseda ligi teise ettevõtte andmetele',
    s2n2: 'Pöördprojekteerida või platvormi kuritarvitada',
    s2n3: 'Häirida süsteemi turvalisust või kättesaadavust',
    s3Title: '3. Kontod ja ligipääs',
    s3p1: 'Igal kasutajal peab olema unikaalne konto',
    s3p2: 'Kasutajad kuuluvad ühte ettevõtte tööruumi',
    s3p3: 'Administraatorid vastutavad ligipääsu ja õiguste haldamise eest',
    s3p4: 'Te vastutate kogu tegevuse eest oma konto all',
    s4Title: '4. Tellimused ja arveldus',
    s4p1: 'Mõned funktsioonid nõuavad tasulist tellimust',
    s4p2: 'Arveldamine toimub korduval alusel (kuiselt või aastaselt)',
    s4p3: 'Hinnad on näidatud ilma käibemaksuta, kui pole märgitud teisiti',
    s4p4: 'Tellimusi saab uuendada või alandada vastavalt plaanireeglitele',
    s4warning: 'Maksmata jätmine võib kaasa tuua teenuse peatamise.',
    s5Title: '5. Tasuta prooviperioodid',
    s5intro: 'Outsprinter võib pakkuda tasuta prooviperioode',
    s5p1: 'Prooviperioodid on ajaliselt piiratud',
    s5p2: 'Funktsioonide juurdepääs võib olla piiratud',
    s5p3: 'Proovikontod võivad aegumiselt muutuda tasulisteks',
    s6Title: '6. Kliendi sisu',
    s6p1: 'Te säilitate omandiõiguse kõigile oma esitatud andmetele ja sisule.',
    s6p2: 'Te annate Outsprinterile piiratud litsentsi',
    s6l1: 'Salvestada',
    s6l2: 'Töödelda',
    s6l3: 'Kuvada',
    s6p3: 'teie sisu ainult teenuse osutamiseks.',
    s6noAi: 'Me ei kasuta kliendi andmeid avalike AI mudelite treenimiseks.',
    s7Title: '7. AI funktsioonid',
    s7p1: 'Outsprinter pakub AI-genereeritud ülevaateid ja soovitusi.',
    s7p2: 'Te kinnitate',
    s7l1: 'AI väljundid on ainult informatiivsed',
    s7l2: 'Lõplikud otsused jäävad teie vastutusele',
    s7l3: 'AI ei asenda professionaalset otsustusviisi',
    s8Title: '8. Andmekaitse ja privaatsus',
    s8p1: 'Me töötleme isikuandmeid kooskõlas meie privaatsusteate ja kehtivate andmekaitsseadustega, sealhulgas GDPR-iga.',
    s9Title: '9. Turvalisus',
    s9p1: 'Me rakendame mõistlikke tehnilisi ja organisatsioonilisi meetmeid teie andmete kaitsmiseks. Siiski ei saa ükski süsteem tagada absoluutset turvalisust.',
    s10Title: '10. Lõpetamine',
    s10p1: 'Te võite oma konto igal ajal lõpetada.',
    s10p2: 'Me võime ligipääsu peatada või lõpetada, kui',
    s10l1: 'Neid tingimusi on rikutud',
    s10l2: 'Seadusega nõutud',
    s10l3: 'Maksekohustusi ei ole täidetud',
    s10p3: 'Lõpetamisel võidakse andmed kustutada vastavalt säilitamispoliitikatele.',
    s11Title: '11. Vastutuse piiramine',
    s11intro: 'Seadusega lubatud maksimaalses ulatuses',
    s11l1: 'Outsprinter ei vastuta kaudsete ega järelduslike kahjude eest',
    s11l2: 'Koguvastutus ei ületa eelmise 12 kuu jooksul makstud tasusid',
    s12Title: '12. Tingimuste muudatused',
    s12p1: 'Me võime neid tingimusi aeg-ajalt uuendada. Teenuse jätkuv kasutamine tähendab uuendatud tingimuste aktsepteerimist.',
    s13Title: '13. Kohaldatav õigus',
    s13p1: 'Neid tingimusi reguleerivad Euroopa Liidu seadused ja kohaldatav kohalik jurisdiktsioon.',
    s14Title: '14. Kontakt',
    s14p1: 'Küsimuste korral nende tingimuste kohta',
  },

  // Privacy Notice
  privacy: {
    title: 'Privaatsusteade',
    effectiveDate: 'Jõustumiskuupäev',
    intro: 'See privaatsusteade selgitab, kuidas Outsprinter kogub, kasutab ja kaitseb isikuandmeid.',
    s1Title: '1. Vastutav töötleja',
    s1p1: 'Outsprinter tegutseb teenuse kaudu töödeldavate isikuandmete vastutava töötlejana.',
    s2Title: '2. Andmed, mida kogume',
    s2intro: 'Me võime koguda',
    s2l1: 'Nimi',
    s2l2: 'E-posti aadress',
    s2l3: 'Ettevõtte teave',
    s2l4: 'Sisselogimise ja kasutusandmed',
    s2l5: 'Arveldusandmed (töödeldakse makseteenuse pakkujate kaudu)',
    s3Title: '3. Kuidas me andmeid kasutame',
    s3intro: 'Me kasutame isikuandmeid',
    s3l1: 'Teenuse pakkumiseks ja opereerimiseks',
    s3l2: 'Kasutajate autentimiseks',
    s3l3: 'Maksete töötlemiseks',
    s3l4: 'Toote funktsionaalsuse parandamiseks',
    s3l5: 'Klienditoe pakkumiseks',
    s3l6: 'Juriidiliste kohustuste täitmiseks',
    s4Title: '4. Töötlemise õiguslik alus',
    s4intro: 'Me töötleme andmeid järgmistel alustel',
    s4l1: 'Lepinguline vajadus',
    s4l2: 'Õigustatud ärilised huvid',
    s4l3: 'Juriidilised kohustused',
    s4l4: 'Kasutaja nõusolek (vajadusel)',
    s5Title: '5. Andmete jagamine',
    s5noSell: 'Me ei müü isikuandmeid.',
    s5share: 'Me võime andmeid jagada',
    s5l1: 'Hostimise ja infrastruktuuri pakkujad',
    s5l2: 'Maksetöötlejad',
    s5l3: 'Analüütikateenused',
    s5l4: 'Õigusasutused vajadusel',
    s5bound: 'Kõik partnerid on lepinguliselt kohustatud andmeid kaitsma.',
    s6Title: '6. Andmete säilitamine',
    s6intro: 'Me säilitame isikuandmeid ainult nii kaua, kui vajalik',
    s6l1: 'Teenuse pakkumiseks',
    s6l2: 'Juriidiliste nõuete täitmiseks',
    s7Title: '7. Teie õigused (GDPR)',
    s7intro: 'Teil on õigus',
    s7l1: 'Pääseda ligi oma andmetele',
    s7l2: 'Parandada ebatäpseid andmeid',
    s7l3: 'Taotleda kustutamist',
    s7l4: 'Piirata või vaidlustada töötlemist',
    s7l5: 'Eksportida oma andmeid',
    s7request: 'Taotlusi saab esitada aadressil',
    s8Title: '8. Turvameetmed',
    s8intro: 'Me kasutame',
    s8l1: 'Krüpteerimist edastamisel ja salvestamisel',
    s8l2: 'Ligipääsukontrolle',
    s8l3: 'Auditilogimist',
    s8l4: 'Turvalist pilveinfrastruktuuri',
    s9Title: '9. Rahvusvahelised edastamised',
    s9p1: 'Kui andmeid edastatakse väljaspool EL-i, kohaldatakse asjakohaseid kaitsemeetmeid.',
    s10Title: '10. Muudatused',
    s10p1: 'Me võime seda privaatsusteadet uuendada. Olulistest muudatustest teavitatakse.',
    s11Title: '11. Kontakt',
    s11p1: 'Privaatsusega seotud küsimuste korral',
  },

  // Cookie Policy
  cookie: {
    title: 'Küpsiste poliitika',
    effectiveDate: 'Jõustumiskuupäev',
    intro: 'See küpsiste poliitika selgitab, kuidas Outsprinter kasutab küpsiseid ja sarnaseid tehnoloogiaid.',
    s1Title: '1. Mis on küpsised?',
    s1p1: 'Küpsised on väikesed tekstifailid, mis salvestatakse teie seadmesse veebisaidi funktsionaalsuse ja kasutajakogemuse parandamiseks.',
    s2Title: '2. Küpsiste tüübid, mida kasutame',
    essential: 'Hädavajalikud küpsised',
    essentialFor: 'Vajalikud',
    e1: 'Autentimine',
    e2: 'Turvalisus',
    e3: 'Põhifunktsionaalsus',
    cannotDisable: 'Neid ei saa keelata.',
    analytics: 'Analüütikaküpsised',
    analyticsFor: 'Kasutatakse mõistmiseks',
    a1: 'Platvormi kasutus',
    a2: 'Funktsioonide jõudlus',
    a3: 'Liiklusmustrid',
    analyticsHelp: 'Need aitavad meil teenust parandada.',
    functional: 'Funktsionaalsed küpsised',
    functionalFor: 'Kasutatakse',
    f1: 'Eelistuste meeldejätmine',
    f2: 'Kasutatavuse parandamine',
    s3Title: '3. Küpsiste haldamine',
    s3p1: 'Saate küpsiseid hallata või keelata brauseri seadete kaudu.',
    s3note: 'Märkus: Hädavajalike küpsiste keelamine võib mõjutada funktsionaalsust.',
    s4Title: '4. Kolmandate osapoolte küpsised',
    s4p1: 'Me võime kasutada usaldusväärseid kolmandate osapoolte tööriistu (nt analüütikateenuse pakkujad). Need pakkujad vastavad kehtivatele andmekaitsseadustele.',
    s5Title: '5. Nõusolek',
    s5p1: 'Vajadusel kasutatakse küpsiseid alles pärast teie nõusoleku saamist küpsiste bänneri kaudu.',
    s6Title: '6. Uuendused',
    s6p1: 'Seda küpsiste poliitikat võidakse aeg-ajalt uuendada.',
    s7Title: '7. Kontakt',
    s7p1: 'Küpsistega seotud küsimuste korral',
  },

  // Press page
  press: {
    title: 'Press',
    subtitle: 'Ressursid ajakirjanikele, meediale ja partneritele.',
    description: 'See leht pakub ametlikku teavet, brändivara ja kontaktandmeid Outsprinteriga seotud pressi- ja meediapäringute jaoks.',
    inquiriesTitle: '📰 Pressipäringud',
    inquiriesDesc: 'Meediapäringute, intervjuude või pressikajastuse jaoks palun pöörduge:',
    pressContact: 'Pressikontakt',
    responseTime: 'Püüame vastata pressipäringutele 48 tunni jooksul.',
    brandTitle: '🎨 Brändivara',
    brandDesc: 'Saadaval taotluse alusel:',
    asset1: 'Ettevõtte logo (hele ja tume versioon)',
    asset2: 'Toote ekraanipildid',
    asset3: 'Asutaja fotod',
    asset4: 'Brändijuhised',
    brandNote: 'Palun kasutage ainult kinnitatud vara ja ärge muutke logosid ega värve.',
    overviewTitle: '🏢 Ettevõtte ülevaade',
    overviewP1: 'Outsprinter on B2B täitmisplatvorm, mis aitab ettevõtetel muuta strateegiat mõõdetavateks tulemusteks. Platvorm ühendab KPI halduse, iganädalase sprindi täitmise, reaalajas töölauad ja AI-põhised ülevaated, et aidata meeskondadel püsida joondatud, fokusseeritud ja vastutustundlikuna.',
    overviewP2: 'Outsprinterit kasutavad idufirmad, kasvuettevõtted, suurettevõtted, avaliku sektori asutused ja mittetulundusühingud täitmise kvaliteedi ja otsuste tegemise parandamiseks.',
    topicsTitle: '🗞️ Teemad, mida kommenteerime',
    topic1: 'Täitmine ja tulemuslikkuse juhtimine',
    topic2: 'KPI-põhine juhtimine',
    topic3: 'Iganädalane rütm ja sprindi täitmine',
    topic4: 'AI otsuste tegemisel',
    topic5: 'Kaasaegsed juhtimispraktikad',
    topic6: 'Meeskondade ja organisatsioonide skaleerimine',
    ctaTitle: '📣 Kajastades täitmist, juhtimist või SaaS innovatsiooni?',
    ctaButton: 'Võta ühendust pressimeeskonnaga',
  },

  // Affiliates page
  affiliates: {
    title: 'Partneriprogramm',
    subtitle: 'Teeni, aidates meeskondadel paremini täita.',
    description: 'Outsprinteri partneriprogramm premeerib partnereid, kes tutvustavad ettevõtetele paremat viisi strateegia täitmiseks, KPI-de jälgimiseks ja iganädalaste sprintide läbiviimiseks.',
    whoTitle: '🤝 Kellele programm on mõeldud',
    whoDesc: 'Partneriprogramm on ideaalne:',
    audience1: 'Konsultandid ja koolitajad',
    audience2: 'Osalise ajaga tegevjuhid ja operatsioonijuhid',
    audience3: 'Nõustajad ja mentorid',
    audience4: 'Agentuurid',
    audience5: 'Sisuloojad',
    audience6: 'SaaS kogukonnad',
    whoNote: 'Kui töötate juhtmeeskondadega, on Outsprinter loomulik valik.',
    howTitle: '💰 Kuidas see toimib',
    step1: 'Soovitate ettevõtet Outsprinterile',
    step2: 'Nad alustavad tasulist tellimust',
    step3: 'Teenite korduvat komisjonitasu',
    howNote: 'Lihtne, läbipaistev ja skaleeritav.',
    commTitle: '💸 Komisjonimudel',
    comm1: 'Konkurentsivõimeline korduv komisjonitasu maksva kliendi kohta',
    comm2: 'Pikaajaline tulu jagamine',
    comm3: 'Teenimisele pole ülempiiri',
    comm4: 'Läbipaistev jälgimise töölaud',
    commNote: 'Täpsed komisjonitasu üksikasjad jagatakse pärast kinnitamist.',
    whyTitle: '🧩 Miks partnerlussuhe Outsprinteriga',
    why1: 'Kõrge väärtusega B2B toode',
    why2: 'Selge väärtuspakkumine',
    why3: 'Tugev hoidmispotentsiaal',
    why4: 'Kasvav nõudlus täitmistööriistade järele',
    why5: 'Pühendunud partneritoetus',
    whyNote: 'Aitate ettevõtetel võita — ja saate selle eest tasu.',
    startTitle: '🚀 Alustamine',
    startDesc: 'Kandideerimiseks',
    startStep1: 'Täitke partneriavaldus',
    startStep2: 'Saate kinnituse',
    startStep3: 'Saate oma unikaalse soovituslingi',
    startStep4: 'Alustage Outsprinteri jagamist',
    applyBtn: 'Kandideeri partneriprogrammi',
    ctaTitle: '📣 Aidake ettevõtetel paremini täita — ja kasvake koos meiega.',
    ctaBtn: 'Saa partneriks',
  },

  // Updates page
  updates: {
    title: 'Uuendused',
    badge: 'Toote uuendused',
    subtitle: 'Toote parandused, uued funktsioonid ja pidev innovatsioon — läbipaistvalt jagatud.',
    introP1: 'Outsprinter on ehitatud pidevalt arenevaks täitmisplatvormiks. Tarnime parandusi regulaarselt, et muuta KPI jälgimine, sprindi täitmine ja AI-põhised ülevaated kiiremaks, targemaks ja usaldusväärsemaks.',
    introP2: 'See leht hoiab teid kursis sellega, mis on uut, mis on parandatud ja mis on tulemas.',
    latestTitle: 'Viimased uuendused',
    latestDesc: 'Püsige kursis iga versiooniga. Iga uuendus keskendub tegelikele klientide vajadustele: parem selgus, kiirem täitmine ja sügavamad ülevaated.',
    latest1: 'Täiustatud KPI puu visualiseerimine suurtele organisatsioonidele',
    latest2: 'Kiirem iganädalane sprindi planeerimine AI-toega prioritiseerimisega',
    latest3: 'Parandatud töölaua jõudlus ja reaalajas uuendamine',
    latest4: 'Uued AI ülevaated täitmisriskide ja tulemuslikkuse trendide kohta',
    latest5: 'Laiendatud administraatori kontrollid ettevõtte ja kasutajate haldamiseks',
    latestNote: 'Iga versioon on kavandatud hõõrdumise vähendamiseks ja otsuste tegemise parandamiseks.',
    releaseTitle: 'Versioonimärkmed',
    releaseDesc: 'Selged, struktureeritud ja läbipaistvad. Iga versioonimärkus sisaldab:',
    whatsNew: 'Mis on uut',
    newFeatures: 'Uued funktsioonid',
    newCapabilities: 'Uued võimalused',
    whatsImproved: 'Mis on parandatud',
    perfEnhancements: 'Jõudluse parandused',
    uxImprovements: 'UX parandused',
    bugFixes: 'Veaparandused',
    securityUpdates: 'Turvauuendused',
    stabilityFixes: 'Stabiilsuse parandused',
    aiTitle: 'AI funktsioonide uuendused',
    aiDesc: 'Targem täitmine iga kuu. Outsprinteri AI assistenti koolitatakse ja parandatakse pidevalt.',
    ai1: 'Targemad KPI soovitused ettevõtte suuruse ja valdkonna põhjal',
    ai2: 'Parandatud sprindi prognoosimise täpsus',
    ai3: 'Parem anomaaliate tuvastamine KPI trendides',
    ai4: 'Toimivamad juhtimisülevaated',
    ai5: 'Täiustatud loomuliku keele kokkuvõtted iganädalasteks ülevaadeteks',
    aiGoal: 'Meie eesmärk: vähem käsitsi analüüsi, kindlamad otsused.',
    betaTitle: 'Beetaprogramm',
    betaDesc: 'Saage varajane ligipääs järgmistele funktsioonidele. Liituge Outsprinteri beetaprogrammiga:',
    betaBenefitsTitle: 'Eelised',
    beta1: 'Testige uusi funktsioone enne avalikku väljaannet',
    beta2: 'Mõjutage toote suunda',
    beta3: 'Andke otsest tagasisidet tootemeeskonnale',
    beta4: 'Saage varajane ligipääs täiustatud AI võimalustele',
    betaGetTitle: 'Beetakasutajad saavad',
    betaGet1: 'Varajased funktsioonilipud',
    betaGet2: 'Prioriteetsed tagasisidekanalid',
    betaGet3: 'Varajase kasutaja tunnustus',
    betaNote: '👉 Saadaval Pro, Business ja Enterprise klientidele.',
    perfTitle: 'Jõudluse ja stabiilsuse parandused',
    perfDesc: 'Me investeerime pidevalt:',
    perf1: 'Kiiremate töölaua laadimisaegade jaoks',
    perf2: 'Parandatud süsteemi usaldusväärsusesse',
    perf3: 'Skaleeritavasse infrastruktuuri kasvavatele meeskondadele',
    perf4: 'Täiustatud andmeturbe ja jälgimisesse',
    perfNote: 'Iga uuendust testitakse minimaalse häire ja maksimaalse stabiilsuse tagamiseks.',
    secTitle: 'Turvalisuse ja vastavuse uuendused',
    secDesc: 'Turvalisust käsitletakse põhitootefunktsioonina. Uuendused hõlmavad:',
    sec1: 'Regulaarsed sõltuvuste uuendused',
    sec2: 'Infrastruktuuri tugevdamine',
    sec3: 'Parandatud ligipääsu logimine',
    sec4: 'GDPR ja andmekaitse täiustused',
    secNote: 'Ettevõtte ja vastavusele suunatud kliente teavitatakse asjakohastest muudatustest ennetavalt.',
    roadmapTitle: 'Mis on tulemas',
    roadmapDesc: 'Meie lähiaja teekaart keskendub:',
    road1: 'Täiustatud AI prognoosimine KPI-de jaoks',
    road2: 'Meeskondadeülene sõltuvuste visualiseerimine',
    road3: 'Parandatud juhatuse tasandi aruandlus',
    road4: 'Sügavamad integratsioonid (CRM, HR, BI tööriistad)',
    road5: 'Kohandatud KPI raamistikud valdkonna järgi',
    roadmapNote: 'Me ehitame klientide sisendiga — ja alati täitmise kvaliteeti silmas pidades.',
    ctaTitle: 'Püsi ees platvormiga, mis ei seisa kunagi paigal.',
  },

  // Consulting page
  consulting: {
    title: 'Konsultatsioon',
    badge: 'Nõustamine ja rakendamine',
    heroTitle: 'Strateegia muutmine tegelikuks täitmiseks',
    heroDesc: 'Paljud ettevõtted teavad, mida tahavad saavutada, kuid vaevlevad täitmisega. Meie konsultandid aitavad teil rakendada uusi sisemisi protsesse, mis tegelikult toimivad igapäevases juhtimises — mitte ainult esitlustes või dokumentides.',
    heroDesc2: 'Aitame teil luua juhtimissüsteemi, mis loob',
    clarity: 'selgust',
    accountability: 'vastutust',
    results: 'mõõdetavaid äritulemusi',
    whatWeDoTitle: 'Mida me teeme',
    whatWeDoDesc: 'Terviklikud konsultatsiooniteenused teie strateegia muutmiseks teostatavaks reaalsuseks',
    service1Title: 'Juhtimise ja KPI raamistiku kujundamine',
    service1Desc: 'Aitame teil defineerida selged eesmärgid (OKR-id, KPI-d) kogu organisatsioonis — ettevõtte tasandist osakondade ja meeskondadeni. Tulemuseks on läbipaistev struktuur, kus igaüks mõistab, kuidas tema töö panustab äritulemustesse.',
    service2Title: 'Protsesside kujundamine ja rakendamine',
    service2Desc: 'Analüüsime teie praeguseid töövooge ning aitame kujundada ja juurutada uusi protsesse, mis:',
    service2b1: 'Parandavad vastutust ja omanditunnet',
    service2b2: 'Vähendavad käsitsi tööd ja ebamäärasust',
    service2b3: 'Loovad distsiplineeritud, korratavat täitmist',
    service3Title: 'Juhtide ja meeskondade võimestamine',
    service3Desc: 'Isegi parimad protsessid ebaõnnestuvad, kui inimesed neid ei kasuta. Töötame tihedalt juhtide ja osakonnajuhtidega, et:',
    service3b1: 'Joondada juhte ümber muutuse olulisuse',
    service3b2: 'Koolitada juhte kasutama KPI-sid igapäevases juhtimises',
    service3b3: 'Juurduda süsteemi ettevõtte juhtimiskultuuri',
    service4Title: 'Mõõtmine, aruandlus ja pidev parandamine',
    service4Desc: 'Loome selged operatsioonirütmid (nt iganädalased KPI ülevaated), töölauad ja visuaalsed aruanded, mis teevad kohe selgeks:',
    service4b1: 'Mis toimib',
    service4b2: 'Kus tulemuslikkus on rajalt maas',
    service4b3: 'Kus on vaja juhtkonna sekkumist',
    whoTitle: 'Kellele see on mõeldud',
    whoDesc: 'Meie konsultatsioon on mõeldud organisatsioonidele, kes on valmis oma täitmist muutma',
    target1: 'Kasvavad B2B ettevõtted',
    target2: 'Tootmis-, teenus- ja tehnoloogiaettevõtted',
    target3: 'Juhtmeeskonnad, kes otsivad selgust ja kontrolli',
    target4: 'Organisatsioonid, kellel on strateegia paigas, kuid nõrk või aeglane täitmine',
    approachTitle: 'Meie lähenemine',
    approach1: 'Praktiline, mitte teoreetiline — keskendunud reaalmaailma kasutusele',
    approach2: 'Süsteemipõhine — eesmärgid, protsessid, inimesed ja tööriistad on joondatud',
    approach3: 'Mõõdetav — iga muudatus peab mõjutama tulemusi',
    approach4: 'Koostööle suunatud — rakendame koos teie juhtmeeskonnaga',
    outcomesTitle: 'Tulemused, mida kliendid kogevad',
    outcome1: 'Täielik läbipaistvus kogu organisatsioonis',
    outcome2: 'Selgem vastutus igal tasandil',
    outcome3: 'Kiirem ja parem otsuste tegemine',
    outcome4: 'Tugevam täitmine ja ennustatavad tulemused',
    outcome5: 'KPI-d, mis toimivad tõeliste juhtimistööriistadena, mitte lihtsalt numbritena',
    engageTitle: 'Kuidas koostöö algab',
    engage1: 'Sissejuhatav konsultatsioon',
    engage2: 'Praeguste juhtimispraktikate hindamine',
    engage3: 'Selged soovitused ja tegevuskava',
    engage4: 'Praktiline rakendamine juhtide ja meeskondadega',
    ctaTitle: 'Valmis oma täitmist muutma?',
    ctaDesc: 'Arutame, kuidas saame aidata teil luua juhtimissüsteemi, mis annab tõelisi tulemusi.',
    ctaBtn1: 'Broneeri tasuta konsultatsioon',
    ctaBtn2: 'Räägime teie väljakutsetest',
  },

  // Blog page
  blog: {
    seoTitle: 'KPI juhtimise blogi - Ekspertide ülevaated ja parimad praktikad',
    seoDesc: 'Õppige KPI juhtimise, tulemuslikkuse jälgimise ja ärijuhtimise kohta. Ekspertartiklid tõhusate KPI süsteemide loomise, iganädalase jälgimise ja andmepõhise otsuste tegemise kohta.',
    badge: 'KPI juhtimise ülevaated',
    title: 'Outsprinteri blogi',
    subtitle: 'Ekspertide ülevaated KPI juhtimise, tulemuslikkuse jälgimise ja andmepõhiste organisatsioonide loomise kohta.',
    searchPlaceholder: 'Otsi artikleid...',
    allArticles: 'Kõik artiklid',
    noResults: 'Teie otsingule vastavaid artikleid ei leitud.',
    clearFilters: 'Tühjenda filtrid',
    ctaTitle: 'Valmis oma KPI juhtimist muutma?',
    ctaDesc: 'Liituge sadade ettevõtetega, kes kasutavad Outsprinterit tulemuslikkuse iganädalaseks jälgimiseks ja paremate otsuste tegemiseks.',
    ctaBtn: 'Alusta tasuta prooviperioodi',
  },

  // Common
  common: {
    loading: 'Laadimine...',
    save: 'Salvesta',
    cancel: 'Tühista',
    delete: 'Kustuta',
    edit: 'Muuda',
    create: 'Loo',
    search: 'Otsi',
    filter: 'Filtreeri',
    noResults: 'Tulemusi ei leitud',
    back: 'Tagasi',
    next: 'Edasi',
    previous: 'Eelmine',
    close: 'Sulge',
    confirm: 'Kinnita',
    yes: 'Jah',
    no: 'Ei',
    and: 'ja',
  },

  // Use Case - Small Startups
  ucStartups: {
    seoTitle: 'Väikeettevõtted (1-20 töötajat)',
    seoDesc: 'Ehita fookus varakult. Tegutse kiiresti. Skaleeri selgusega. Outsprinter aitab väikestel meeskondadel püsida joondatud, fokusseeritud ja täitmisele suunatud alates esimesest päevast.',
    badge: 'Väikeettevõtted (1–20 töötajat)',
    heroTitle: 'Ehita fookus varakult. Tegutse kiiresti. Skaleeri selgusega.',
    heroDesc: 'Varajase faasi idufirmad liiguvad kiiresti — kuid kiirus ilma struktuurita muutub kiiresti kaoseks. Outsprinter aitab väikestel meeskondadel püsida joondatud, fokusseeritud ja täitmisele suunatud alates esimesest päevast, ilma rasket protsessi või ettevõtte keerukust lisamata.',
    challengeTitle: 'Väljakutse väikeettevõtetele',
    challengeIntro: 'Idufirmad võitlevad tavaliselt:',
    ch1: 'Liiga palju ideid, liiga vähe fookust',
    ch2: 'Eesmärgid, mis muutuvad iganädalaselt ilma jälgimiseta',
    ch3: 'KPI-d elavad tabelites või neid ei jälgita üldse',
    ch4: 'Asutajad hoiavad kõike oma peas',
    ch5: 'Meeskonnad töötavad kõvasti, kuid mitte alati õigetel asjadel',
    challengeConclusion: 'Täitmine muutub reaktiivseks, mitte kavatsuslikuks.',
    howTitle: 'Kuidas Outsprinter aitab väikestel meeskondadel võita',
    howIntro: 'Outsprinter annab idufirmadele kerge täitmissüsteemi, mis skaleerub koos nendega.',
    howSubIntro: 'Outsprinteriga saavad idufirmad:',
    how1: 'Defineerida selged ettevõtte eesmärgid ja KPI-d',
    how2: 'Tõlkida strateegia iganädalasteks sprintideks',
    how3: 'Jälgida edenemist ilma bürokraatiata',
    how4: 'Hoida kõiki joondatuna, kui meeskond kasvab',
    how5: 'Luua täitmisdistsipliini varakult',
    howConclusion: 'Ei mingit projektijuhtimise ülekoormust. Ei mingit KPI kaost.',
    workflowTitle: 'Tüüpiline idufirma töövoog Outsprinteris',
    wf1Title: 'Nädal 1 – Seadistamine',
    wf1a: 'Asutaja seab ettevõtte tasandi KPI-d',
    wf1b: 'Loo 2–3 meeskonda (nt Toode, Müük, Ops)',
    wf1c: 'Määra igale KPI-le vastutaja',
    wf1d: 'Kutsu meeskonnaliikmed',
    wf2Title: 'Iganädalane rütm',
    wf2a: 'Planeeri iganädalane sprint (ainult top 3 prioriteeti)',
    wf2b: 'Uuenda KPI-sid kord nädalas',
    wf2c: 'Vaata sprindi tulemused üle 10–15 minutiga',
    wf2d: 'AI genereerib kokkuvõtte ja parandusettepanekud',
    wf3Title: 'Juhtkonna vaade',
    wf3a: 'Asutaja näeb ettevõtte tervist ühel töölaual',
    wf3b: 'Teab koheselt, mis töötab ja mis mitte',
    featuresTitle: 'Põhifunktsioonid väikeettevõtetele',
    feat1Title: 'KPI haldur',
    feat1a: 'Lihtne KPI seadistamine',
    feat1b: 'Visuaalne KPI puu',
    feat1c: 'Automaatsed staatuse indikaatorid (roheline / kollane / punane)',
    feat2Title: 'Meeskonna sprindi haldur',
    feat2a: 'Iganädalane sprindi planeerimine',
    feat2b: 'Selge vastutus',
    feat2c: 'Fookus sellele, mis tegelikult loeb',
    feat3Title: 'Nutikas AI assistent',
    feat3a: 'KPI soovitused',
    feat3b: 'Iganädalased kokkuvõtted',
    feat3c: 'Täitmisülevaated',
    feat4Title: 'Töölauad',
    feat4a: 'Ettevõtte ülevaade',
    feat4b: 'Meeskonna tasandi edenemine',
    feat4c: 'Iganädalane täitmise tervis',
    resultsTitle: 'Tulemused, mida idufirmad saavutavad',
    resultsIntro: 'Outsprinterit kasutavad idufirmad kogevad tavaliselt:',
    res1: 'Kiirem otsuste tegemine',
    res2: 'Selgemad prioriteedid',
    res3: 'Parem asutaja nähtavus',
    res4: 'Vähenenud kaos meeskonna kasvades',
    res5: 'Tugevad täitmisharjumused alates esimesest päevast',
    resultsConclusion: 'Outsprinter aitab asutajatel lõpetada oletamise — ja hakata juhtima andmetega.',
    whyTitle: 'Miks Outsprinter sobib ideaalselt varajastele meeskondadele',
    why1: 'Kiire seadistamine (alla 30 minuti)',
    why2: 'Minimaalne halduskoormus',
    why3: 'Ei mingeid keerulisi konfiguratsioone',
    why4: 'Kasvab koos ettevõttega',
    why5: 'Loodud täitmiseks, mitte aruandluseks',
    whyConclusion: 'Sa ei vaja keerulist süsteemi. Sa vajad selgust ja järjepidevust.',
    ctaTitle: 'Ehita täitmisdistsipliin algusest peale.',
  },

  // Use Case - SMB
  ucSMB: {
    seoTitle: 'Väikesed ja keskmised ettevõtted (21-200 töötajat)',
    seoDesc: 'Loo joondatus meeskondade vahel. Teosta mastaapselt. Püsi kontrolli all. Outsprinter annab kasvavatele ettevõtetele selge täitmissüsteemi.',
    badge: 'Väikesed ja keskmised ettevõtted (21–200 töötajat)',
    heroTitle: 'Loo joondatus meeskondade vahel. Teosta mastaapselt. Püsi kontrolli all.',
    heroDesc: 'Kui ettevõtted kasvavad idufirma faasist välja, muutub täitmine raskemaks — mitte lihtsamaks. Rohkem meeskondi, rohkem juhte, rohkem prioriteete ja rohkem andmeid viivad sageli ebakõlani ja aeglasemate otsusteni. Outsprinter annab kasvavatele ettevõtetele selge täitmissüsteemi, mis hoiab juhtkonna, meeskonnad ja KPI-d joondatuna — ilma bürokraatiat lisamata.',
    challengeTitle: 'Väljakutse kasvavatele ettevõtetele',
    challengeIntro: 'VKE-d võitlevad tavaliselt:',
    ch1: 'Meeskonnad töötavad eraldatult',
    ch2: 'Osakonna eesmärgid pole joondatud ettevõtte strateegiaga',
    ch3: 'KPI-sid jälgitakse ebaregulaarselt või liiga hilja',
    ch4: 'Iganädalased koosolekud ilma tegelike andmeteta',
    ch5: 'Juhid reageerivad selle asemel et juhtida',
    challengeConclusion: 'Kasv toob esile täitmise lüngad.',
    howTitle: 'Kuidas Outsprinter toob struktuuri ilma teid aeglustamata',
    howIntro: 'Outsprinter toob struktuuri sinna, kus seda vaja on — ja paindlikkust sinna, kus see loeb.',
    howSubIntro: 'Outsprinteriga saavad VKE-d:',
    how1: 'Ühendada ettevõtte strateegia osakonna KPI-dega',
    how2: 'Viia läbi järjepidevaid iganädalasi sprinte meeskondades',
    how3: 'Jälgida täitmist reaalajas',
    how4: 'Tuvastada riske varakult',
    how5: 'Säilitada kiirust skaleerimisel',
    howConclusion: 'Täitmine muutub kavatsuslikuks, nähtavaks ja korratavaks.',
    workflowTitle: 'Tüüpiline VKE töövoog Outsprinteris',
    wf1Title: 'Ettevõtte seadistamine',
    wf1a: 'Juhtkond defineerib ettevõtte tasandi KPI-d',
    wf1b: 'Osakonnad loovad joondatud KPI-d',
    wf1c: 'Omanikud määratud igale mõõdikule',
    wf2Title: 'Iganädalane täitmine',
    wf2a: 'Meeskonnad planeerivad iganädalasi sprinte',
    wf2b: 'KPI-d uuendatakse kord nädalas',
    wf2c: 'Juhid vaatavad töölauad üle',
    wf2d: 'AI toob esile riskid ja parandamist vajavad valdkonnad',
    wf3Title: 'Juhtkonna ülevaade',
    wf3a: 'Tegevjuht vaatab ettevõtte töölauda',
    wf3b: 'Punased KPI-d käivitavad fookustatud arutelud',
    wf3c: 'Otsused tehakse faktide põhjal',
    featuresTitle: 'Põhifunktsioonid VKE-dele',
    feat1Title: 'KPI puu',
    feat1a: 'Selge hierarhia ettevõte → osakond → KPI',
    feat1b: 'Visuaalne joondatus kogu organisatsioonis',
    feat2Title: 'Iganädalane sprindi haldus',
    feat2a: 'Struktureeritud sprindi planeerimine',
    feat2b: 'Fookustatud täitmine',
    feat2c: 'Mõõdetavad tulemused',
    feat3Title: 'Töölauad',
    feat3a: 'Ettevõtteülene ülevaade',
    feat3b: 'Osakonna tulemuslikkuse töölauad',
    feat3c: 'Trendide analüüs',
    feat4Title: 'Nutikas AI assistent',
    feat4a: 'Iganädalased tulemuslikkuse kokkuvõtted',
    feat4b: 'Riskide tuvastamine',
    feat4c: 'Täitmisülevaated',
    resultsTitle: 'Mõõdetavad tulemused VKE-dele',
    resultsIntro: 'Ettevõtted näevad tavaliselt:',
    res1: 'Tugevam meeskondadeülene joondatus',
    res2: 'Kiiremad juhtimisotsused',
    res3: 'Vähem üllatusi tulemuslikkuses',
    res4: 'Selge vastutus tulemuste eest',
    res5: 'Kõrgem täitmise järjepidevus',
    resultsConclusion: 'Outsprinter muudab kasvu konkurentsieeliseks — mitte riskiks.',
    whyTitle: 'Miks Outsprinter sobib kasvavatele organisatsioonidele',
    why1: 'Loodud mitme meeskonnaga keskkondadele',
    why2: 'Skaleerub ilma uuesti juurutamiseta',
    why3: 'Töötab nii juhtkonna kui meeskondade jaoks',
    why4: 'Jõustab distsipliini ilma mikromanageerimiseta',
    whyConclusion: 'See on täitmissüsteem, mitte lihtsalt järjekordne tööriist.',
    ctaTitle: 'Skaleeri täitmist selgust kaotamata.',
  },

  // Use Case - Enterprise
  ucEnterprise: {
    seoTitle: 'Suurettevõtted',
    seoDesc: 'Ettevõttetasemel täitmine, nähtavus ja vastutus — mastaapselt. Ühenda strateegia, KPI-d, meeskonnad ja juhtkond üheks läbipaistvaks platvormiks.',
    badge: 'Suurettevõtted',
    heroTitle: 'Ettevõttetasemel täitmine, nähtavus ja vastutus — mastaapselt.',
    heroDesc: 'Suured organisatsioonid ei võitle strateegiaga — nad võitlevad täitmisega mastaapselt. Mitu äriüksust, keerulised struktuurid ja viivitatud nähtavus viivad sageli aeglaste otsuste ja kasutamata võimalusteni. Outsprinter annab suurettevõtetele ühe täitmise operatsioonisüsteemi, mis ühendab strateegia, KPI-d, meeskonnad ja juhtkonna üheks läbipaistvaks reaalajas platvormiks.',
    challengeTitle: 'Suurettevõtte täitmise väljakutse',
    challengeIntro: 'Suurettevõtted seisavad sageli silmitsi:',
    ch1: 'Ühendamata äriüksused ja KPI-d',
    ch2: 'Viivitatud või filtreeritud tulemuslikkuse aruandlus',
    ch3: 'Liiga palju tööriistu ja killustatud andmed',
    ch4: 'Aeglane reageerimine alatulemuslikkusele',
    ch5: 'Reaalajas nähtavuse puudumine juhtidele',
    challengeConclusion: 'Täitmine muutub keeruliseks, läbipaistmatuks ja reaktiivseks.',
    howTitle: 'Kuidas Outsprinter toetab suurettevõtte täitmist',
    howIntro: 'Outsprinter on loodud selguse ja struktuuri toomiseks ilma "üks suurus sobib kõigile" protsessi peale surumata.',
    howSubIntro: 'Outsprinteriga saavad suurettevõtted:',
    how1: 'Joondada korporatiivstrateegia äriüksuste KPI-dega',
    how2: 'Säilitada järjepideva täitmistrütmi osakondades',
    how3: 'Pakkuda juhtidele reaalajas nähtavust',
    how4: 'Tuvastada riske varem AI analüüsi kaudu',
    how5: 'Standardiseerida täitmist, lubades samal ajal kohalikku autonoomsust',
    workflowTitle: 'Tüüpiline suurettevõtte töövoog Outsprinteris',
    wf1Title: 'Strateegiline joondatus',
    wf1a: 'Nõukogu ja juhtkond defineerivad tipptaseme eesmärgid',
    wf1b: 'Äriüksused loovad joondatud KPI-d',
    wf1c: 'Omandiõigus määratud kõigil tasanditel',
    wf2Title: 'Operatiivne täitmine',
    wf2a: 'Meeskonnad teevad iganädalasi sprinte määratud raamistikes',
    wf2b: 'KPI-d uuendatakse järjepidevalt',
    wf2c: 'AI jälgib trende ja anomaaliaid',
    wf3Title: 'Juhtkonna järelevalve',
    wf3a: 'Juhid vaatavad ettevõtteüleseid töölaudu',
    wf3b: 'Punased KPI-d käivitavad kohese fookuse',
    wf3c: 'Prognoosi töölauad toetavad strateegilisi otsuseid',
    featuresTitle: 'Ettevõttetasemel funktsioonid',
    feat1Title: 'Täiustatud KPI raamistikud',
    feat1a: 'Mitmetasandilised KPI puud',
    feat1b: 'Kohandatud KPI raamistikud äriüksuse järgi',
    feat1c: 'Koond- ja süvavaated',
    feat2Title: 'Juhtkonna töölauad',
    feat2a: 'Nõukogu tasandi töölauad',
    feat2b: 'Juhtkonna kokkuvõtted',
    feat2c: 'Trendide ja prognooside analüüs',
    feat3Title: 'Turvalisus ja vastavus',
    feat3a: 'Rollipõhine ligipääsu kontroll',
    feat3b: 'Auditilogid',
    feat3c: 'Ühekordne sisselogimine (SSO)',
    feat3d: 'Andmete residentsuse valikud',
    feat4Title: 'AI ülevaated',
    feat4a: 'Ennustav riskianalüüs',
    feat4b: 'Üksustevahelised tulemuslikkuse võrdlused',
    feat4c: 'Täitmise pudelikaela tuvastamine',
    resultsTitle: 'Suurettevõtte tulemused',
    resultsIntro: 'Organisatsioonid saavutavad tavaliselt:',
    res1: 'Kiirem juhtimisotsuste tegemine',
    res2: 'Selge vastutus üksuste üleselt',
    res3: 'Vähenenud aruandluse halduskoormus',
    res4: 'Parem täitmise järjepidevus',
    res5: 'Suurenenud organisatsiooniline usaldus',
    resultsConclusion: 'Outsprinter muudab keerukuse selguseks.',
    whyTitle: 'Loodud suurettevõtte reaalsusele',
    why1: 'Toetab keerulisi org struktuure',
    why2: 'Paindlikud juhtimismudelid',
    why3: 'Ettevõttetasemel turvalisus',
    why4: 'Pühendunud juurutamine ja tugi',
    whyConclusion: 'Outsprinter kohandub sellega, kuidas suurettevõtted töötavad — mitte vastupidi.',
    ctaTitle: 'Too selgus suurettevõtte täitmisse.',
    ctaBtn1: 'Küsi ettevõtte demo',
    ctaBtn2: 'Räägi müügiga',
  },

  // Use Case - IT Teams
  ucIT: {
    seoTitle: 'IT meeskonnad',
    seoDesc: 'Muuda tehniline pingutus mõõdetavaks ärimõjuks. Joonda tehniline täitmine ärieesmärkidega ja jälgi tähendusrikkaid KPI-sid.',
    badge: 'IT meeskonnad',
    heroTitle: 'Muuda tehniline pingutus mõõdetavaks ärimõjuks.',
    heroDesc: 'IT meeskonnad on pideva surve all tarnida kiiresti, säilitada stabiilsust ja toetada äri — sageli muutuvate prioriteetide ja piiratud nähtavusega sellesse, mis tegelikult loeb. Outsprinter aitab IT meeskondadel joondada tehnilise täitmise ärieesmärkidega, jälgida tähendusrikkaid KPI-sid ja viia läbi fookustatud iganädalasi sprinte ilma tarbetu halduskoormuseta.',
    challengeTitle: 'Väljakutse IT meeskondadele',
    challengeIntro: 'IT ja insenerimeeskonnad seisavad sageli silmitsi:',
    ch1: 'Ebaselged või muutuvad prioriteedid',
    ch2: 'Liiga palju ülesandeid, liiga vähe fookust',
    ch3: 'KPI-d, mis ei peegelda tegelikku mõju',
    ch4: 'Sprindi töö pole seotud äritulemustega',
    ch5: 'Juhtkond ei mõista täielikult tarne piiranguid',
    challengeConclusion: 'See viib frustratsiooni, ülekoormuse ja ebakõlani.',
    howTitle: 'Kuidas Outsprinter võimestab IT meeskondi',
    howIntro: 'Outsprinter ühendab tehnilise täitmise otse ettevõtte eesmärkidega.',
    howSubIntro: 'Outsprinteriga saavad IT meeskonnad:',
    how1: 'Defineerida selged tehnilised KPI-d seotud ärieesmärkidega',
    how2: 'Viia läbi struktureeritud iganädalasi sprinte nähtavate tulemustega',
    how3: 'Jälgida tarne tulemuslikkuse ja usaldusväärsuse mõõdikuid',
    how4: 'Kommunikeerida edenemist selgelt juhtkonnale',
    how5: 'Vähendada kontekstivahetust ja tulekahjude kustutamist',
    howConclusion: 'Täitmine muutub ennustatavaks ja läbipaistvaks.',
    workflowTitle: 'Tüüpiline IT meeskonna töövoog Outsprinteris',
    wf1Title: 'Seadistamine',
    wf1a: 'Defineeri tehnilised KPI-d (tööaeg, kiirus, intsidendi lahendamine, tarneaeg)',
    wf1b: 'Joonda KPI-d ettevõtte eesmärkidega',
    wf1c: 'Määra omandiõigus',
    wf2Title: 'Iganädalane täitmine',
    wf2a: 'Planeeri iganädalased sprindi prioriteedid',
    wf2b: 'Jälgi sprindi edenemist',
    wf2c: 'Uuenda KPI-sid kord nädalas',
    wf2d: 'AI toob esile riskid ja pudelikaelad',
    wf3Title: 'Juhtkonna aruandlus',
    wf3a: 'IT töölauad näitavad tarne tervist',
    wf3b: 'Juhid näevad mõju ilma mikromanageerimiseta',
    featuresTitle: 'Põhifunktsioonid IT meeskondadele',
    feat1Title: 'KPI haldur',
    feat1a: 'Tehnilised KPI mallid',
    feat1b: 'Trendide jälgimine',
    feat1c: 'SLA ja usaldusväärsuse mõõdikud',
    feat2Title: 'Sprindi haldur',
    feat2a: 'Iganädalane sprindi planeerimine',
    feat2b: 'Tarne jälgimine',
    feat2c: 'Mahu teadlikkus',
    feat3Title: 'Töölauad',
    feat3a: 'Sprindi tervise töölaud',
    feat3b: 'Tehnilise tulemuslikkuse trendid',
    feat3c: 'Tarne kiiruse mõõdikud',
    feat4Title: 'Nutikas AI assistent',
    feat4a: 'Sprindi riski tuvastamine',
    feat4b: 'Ülekoormuse hoiatused',
    feat4c: 'Tarne mustrite analüüs',
    resultsTitle: 'Tulemused, mida IT meeskonnad saavutavad',
    resultsIntro: 'Meeskonnad näevad tavaliselt:',
    res1: 'Selgemad prioriteedid',
    res2: 'Parem sprindi ennustatavus',
    res3: 'Vähem tulekahjude kustutamist',
    res4: 'Paranenud suhtlus juhtkonnaga',
    res5: 'KPI-d, mis peegeldavad tegelikku väärtust',
    resultsConclusion: 'Outsprinter aitab IT meeskondadel tõestada mõju — mitte ainult tegevust.',
    whyTitle: 'Miks Outsprinter töötab IT jaoks',
    why1: 'Kerge võrreldes raskete projektitööriistadega',
    why2: 'KPI-põhine, mitte ülesandepõhine',
    why3: 'Täiendab tööriistu nagu Jira, mitte ei asenda neid',
    why4: 'Loodud selguse ja täitmise jaoks',
    ctaTitle: 'Joonda tehnoloogia tulemustega.',
  },

  // Use Case - Operations
  ucOps: {
    seoTitle: 'Operatsioonide meeskonnad',
    seoDesc: 'Muuda operatsioonid mõõdetavaks, ennustatavaks ja pidevalt paranevaks. Jälgi tulemuslikkust iganädalaselt ja paranda täitmist selgusega.',
    badge: 'Operatsioonide meeskonnad',
    heroTitle: 'Muuda operatsioonid mõõdetavaks, ennustatavaks ja pidevalt paranevaks.',
    heroDesc: 'Operatsioonide meeskonnad hoiavad äri töös — kuid nende mõju on sageli peidetud keerukuse, käsitsi aruandluse ja reaktiivse probleemide lahendamise taha. Outsprinter aitab operatsioonide meeskondadel defineerida õiged KPI-d, jälgida tulemuslikkust iganädalaselt ning parandada täitmist selguse ja distsipliiniga.',
    challengeTitle: 'Väljakutse operatsioonide meeskondadele',
    challengeIntro: 'Operatsioonide meeskonnad võitlevad sageli:',
    ch1: 'Liiga palju mõõdikuid ilma selgete prioriteetideta',
    ch2: 'Tulemuslikkuse probleemid avastatakse liiga hilja',
    ch3: 'Käsitsi aruandlus ja tabelid',
    ch4: 'Nähtavuse puudumine meeskondade ja protsesside üleselt',
    ch5: 'Pidev tulekahjude kustutamine parandamise asemel',
    challengeConclusion: 'See viib ebaefektiivsuse ja tarbetu riskini.',
    howTitle: 'Kuidas Outsprinter tugevdab operatsioonide täitmist',
    howIntro: 'Outsprinter annab operatsioonide meeskondadele süsteemi, et:',
    how1: 'Defineerida operatiivsed KPI-d, mis tegelikult loevad',
    how2: 'Jälgida tulemuslikkust iganädalaselt kuu asemel',
    how3: 'Tuvastada pudelikaelad varakult',
    how4: 'Joondada meeskonnad parandusprioriteetide ümber',
    how5: 'Kommunikeerida tulemuslikkust selgelt juhtkonnale',
    howConclusion: 'Operatsioonid muutuvad proaktiivseks — mitte reaktiivseks.',
    workflowTitle: 'Tüüpiline operatsioonide töövoog Outsprinteris',
    wf1Title: 'Seadistamine',
    wf1a: 'Defineeri operatiivsed KPI-d (tsükliaeg, kuluefektiivsus, kvaliteet, läbilaskevõime)',
    wf1b: 'Määra KPI omandiõigus',
    wf1c: 'Joonda KPI-d ettevõtte eesmärkidega',
    wf2Title: 'Iganädalane rütm',
    wf2a: 'Uuenda KPI-sid iganädalaselt',
    wf2b: 'Vaata operatiivsed töölauad üle',
    wf2c: 'Planeeri parandussprindid',
    wf2d: 'AI toob esile trendid ja riskid',
    wf3Title: 'Juhtkonna joondamine',
    wf3a: 'Jaga selgeid operatiivseid töölaudu',
    wf3b: 'Fookusta arutelud punastele ja kollastele KPI-dele',
    featuresTitle: 'Põhifunktsioonid operatsioonide meeskondadele',
    feat1Title: 'KPI haldur',
    feat1a: 'Operatiivsed KPI mallid',
    feat1b: 'Trendide analüüs',
    feat1c: 'Künnisepõhised hoiatused',
    feat2Title: 'Sprindi haldur',
    feat2a: 'Parandussprindid',
    feat2b: 'Protsessi optimeerimise jälgimine',
    feat2c: 'Selge vastutus',
    feat3Title: 'Töölauad',
    feat3a: 'Operatiivse tulemuslikkuse ülevaade',
    feat3b: 'Trendide töölauad',
    feat3c: 'Efektiivsuse soojuskaardid',
    feat4Title: 'Nutikas AI assistent',
    feat4a: 'Pudelikaela tuvastamine',
    feat4b: 'Tulemuslikkuse anomaalia hoiatused',
    feat4c: 'Parandussoovitused',
    resultsTitle: 'Tulemused, mida operatsioonide meeskonnad saavutavad',
    resultsIntro: 'Meeskonnad saavutavad tavaliselt:',
    res1: 'Vähenenud operatiivne risk',
    res2: 'Kiirem probleemide tuvastamine',
    res3: 'Paranenud efektiivsus',
    res4: 'Selge vastutus',
    res5: 'Pideva parandamise kultuur',
    resultsConclusion: 'Outsprinter muudab operatsioonid konkurentsieeliseks.',
    whyTitle: 'Miks Outsprinter sobib operatsioonide meeskondadele',
    why1: 'KPI-põhine lähenemine',
    why2: 'Iganädalane täitmise rütm',
    why3: 'Selge nähtavus ilma mikromanageerimiseta',
    why4: 'Loodud pidevaks parandamiseks',
    ctaTitle: 'Juhi operatsioone kindlustundega.',
  },

  // Use Case - Sales
  ucSales: {
    seoTitle: 'Müügimeeskonnad',
    seoDesc: 'Muuda müügitegevus ennustatavaks tuluks ja selgeks vastutuseks. Jälgi müügitoru tervist iganädalaselt ja anna juhtkonnale reaalajas nähtavus.',
    badge: 'Müügimeeskonnad',
    heroTitle: 'Muuda müügitegevus ennustatavaks tuluks ja selgeks vastutuseks.',
    heroDesc: 'Müügimeeskondi mõõdetakse tulemuste järgi — kuid liiga sageli tuleb nähtavus liiga hilja. Müügitorud näevad terved välja kuni nad enam ei ole, prognoosid põhinevad oletustel ja täitmise lüngad ilmnevad alles kuu lõpus. Outsprinter aitab müügimeeskondadel defineerida õiged KPI-d, viia läbi fookustatud iganädalasi sprinte ja anda juhtkonnale reaalajas nähtavus tulu tulemuslikkusesse.',
    challengeTitle: 'Väljakutse müügimeeskondadele',
    challengeIntro: 'Müügiorganisatsioonid seisavad sageli silmitsi:',
    ch1: 'Tegevuspõhine, tulemusvaene aruandlus',
    ch2: 'KPI-sid vaadatakse üle kord kuus nädala asemel',
    ch3: 'Prognoosid põhinevad kõhutundel',
    ch4: 'Kehv joondatus müügistrateegia ja igapäevase täitmise vahel',
    ch5: 'Piiratud nähtavus juhtkonnale',
    challengeConclusion: 'See loob volatiilsust ja täitmata eesmärke.',
    howTitle: 'Kuidas Outsprinter parandab müügi täitmist',
    howIntro: 'Outsprinter ühendab müügistrateegia iganädalase tegevusega.',
    howSubIntro: 'Outsprinteriga saavad müügimeeskonnad:',
    how1: 'Defineerida tulemusele suunatud müügi KPI-d',
    how2: 'Jälgida müügitoru tervist iganädalaselt',
    how3: 'Viia läbi fookustatud müügisprinte',
    how4: 'Tuvastada riske varakult',
    how5: 'Joondada müügitegevus tulueesmärkidega',
    howConclusion: 'Täitmine muutub mõõdetavaks, läbipaistvaks ja järjepidevaks.',
    workflowTitle: 'Tüüpiline müügi töövoog Outsprinteris',
    wf1Title: 'Seadistamine',
    wf1a: 'Defineeri müügi KPI-d (müügitoru väärtus, konversioonimäär, võidumäär, tehingu kiirus, ARR/MRR)',
    wf1b: 'Joonda KPI-d ettevõtte tulueesmärkidega',
    wf1c: 'Määra selge vastutus',
    wf2Title: 'Iganädalane müügirütm',
    wf2a: 'Planeeri iganädalased müügisprindid (tipptehingud, võtmetegevused)',
    wf2b: 'Uuenda KPI-sid iganädalaselt',
    wf2c: 'Vaata töölaua tulemuslikkus üle',
    wf2d: 'AI toob esile riskid ja võimalused',
    wf3Title: 'Juhtkonna ülevaade',
    wf3a: 'Müügijuhid ja tegevjuhid näevad reaalajas töölaudu',
    wf3b: 'Alatulemuslikud KPI-d käivitavad fookustatud tegevuse',
    featuresTitle: 'Põhifunktsioonid müügimeeskondadele',
    feat1Title: 'KPI haldur',
    feat1a: 'Tulule suunatud KPI mallid',
    feat1b: 'Müügitoru ja konversiooni jälgimine',
    feat1c: 'Trendide analüüs',
    feat2Title: 'Sprindi haldur',
    feat2a: 'Iganädalased tehingufookusega sprindid',
    feat2b: 'Selged prioriteedid',
    feat2c: 'Täitmise jälgimine',
    feat3Title: 'Töölauad',
    feat3a: 'Müügi tulemuslikkuse töölaud',
    feat3b: 'Müügitoru tervise ülevaade',
    feat3c: 'Prognoosi trendid',
    feat4Title: 'Nutikas AI assistent',
    feat4a: 'Tehingu riski tuvastamine',
    feat4b: 'Müügitoru kvaliteedi analüüs',
    feat4c: 'Prognoosi täpsuse ülevaated',
    resultsTitle: 'Tulemused, mida müügimeeskonnad saavutavad',
    resultsIntro: 'Müügimeeskonnad näevad tavaliselt:',
    res1: 'Ennustatavam tulu',
    res2: 'Kõrgem prognoosi täpsus',
    res3: 'Selged müügiprioriteedid',
    res4: 'Kiirem reageerimine müügitoru riskidele',
    res5: 'Parem joondatus juhtkonnaga',
    resultsConclusion: 'Outsprinter aitab müügimeeskondadel keskenduda sulgemisele — mitte aruandlusele.',
    whyTitle: 'Miks Outsprinter töötab müügi jaoks',
    why1: 'KPI-põhine, mitte tegevuspõhine',
    why2: 'Iganädalane rütm igakuiste üllatuste asemel',
    why3: 'Selge juhtkonna nähtavus',
    why4: 'Täiendab CRM-e nagu HubSpot või Pipedrive',
    ctaTitle: 'Muuda tulu täitmine ennustatavaks.',
  },

  // Use Case - Management Board
  ucBoard: {
    seoTitle: 'Juhatus',
    seoDesc: 'Juhatuse tasandi selgus. Reaalajas ülevaade. Kindlad otsused. Saa selge, reaalajas vaade ettevõtte tulemuslikkusest ja strateegilisest edenemisest.',
    badge: 'Juhatus',
    heroTitle: 'Juhatuse tasandi selgus. Reaalajas ülevaade. Kindlad otsused.',
    heroDesc: 'Nõukogud ja juhtmeeskonnad vastutavad suuna, järelevalve ja tulemuste eest — siiski saavad nad liiga sageli viivitatud, filtreeritud või liiga keerulisi aruandeid, mis teeb tegeliku otsustamise raskeks. Outsprinter annab juhtkondadele selge, reaalajas vaate ettevõtte tulemuslikkusest, täitmisriskidest ja strateegilisest edenemisest — uppumata operatiivsesse detaili.',
    challengeTitle: 'Väljakutse juhtkondadele',
    challengeIntro: 'Nõukogud ja juhtmeeskonnad seisavad sageli silmitsi:',
    ch1: 'Tulemuslikkuse andmed saabuvad liiga hilja',
    ch2: 'Aruanded filtreeritud läbi mitme kihi',
    ch3: 'Ebaühtlased KPI definitsioonid osakondade vahel',
    ch4: 'Raskused tegelike riskide varajasel tuvastamisel',
    ch5: 'Koosolekud keskenduvad selgitustele otsuste asemel',
    challengeConclusion: 'See nõrgestab valitsemist ja aeglustab strateegilist tegevust.',
    howTitle: 'Kuidas Outsprinter toetab nõukogusid ja juhte',
    howIntro: 'Outsprinter on loodud tõe, mitte müra esiletoomiseks.',
    howSubIntro: 'Outsprinteriga saavad nõukogud:',
    how1: 'Näha ettevõtte tasandi KPI-sid reaalajas',
    how2: 'Jälgida täitmist strateegiliste eesmärkide vastu',
    how3: 'Tuvastada riske enne nende eskaleerumist',
    how4: 'Võrrelda trende osakondade vahel',
    how5: 'Keskenduda aruteludes tulemustele, mitte arvamustele',
    howConclusion: 'See võimaldab nõukogudel valitseda proaktiivselt — mitte reaktiivselt.',
    workflowTitle: 'Tüüpiline nõukogu töövoog Outsprinteris',
    wf1Title: 'Strateegiline seadistamine',
    wf1a: 'Ettevõtte strateegia tõlgitud tipptaseme KPI-deks',
    wf1b: 'Selge omandiõigus määratud juhtimisrollidele',
    wf1c: 'KPI eesmärgid kinnitatud nõukogu tasandil',
    wf2Title: 'Pidev järelevalve',
    wf2a: 'KPI-d uuendatakse juhtkonna poolt iganädalaselt',
    wf2b: 'Nõukogu töölauad uuenevad automaatselt reaalajas',
    wf2c: 'AI märgistab riskid, kõrvalekalded ja anomaaliad',
    wf3Title: 'Nõukogu koosolekud',
    wf3a: 'Koosolekud algavad live töölauaga',
    wf3b: 'Punased ja kollased KPI-d juhivad arutelu',
    wf3c: 'Otsused on andmepõhised ja fookustatud',
    featuresTitle: 'Põhifunktsioonid juhtkondadele',
    feat1Title: 'Nõukogu tasandi töölauad',
    feat1a: 'Kõrgetasemeline KPI ülevaade',
    feat1b: 'Trendi ja prognoosi vaated',
    feat1c: 'Riskiindikaatorid',
    feat2Title: 'Süvitsimineku võimekus',
    feat2a: 'Ettevõtte KPI-dest osakonna tulemuslikkuseni',
    feat2b: 'Ilma tarbetut operatiivset müra paljastamata',
    feat3Title: 'AI ülevaated',
    feat3a: 'Varajase hoiatuse signaalid',
    feat3b: 'Tulemuslikkuse mustri analüüs',
    feat3c: 'Strateegilised täitmisriskid',
    feat4Title: 'Valitsemine ja läbipaistvus',
    feat4a: 'Järjepidevad mõõdikud kogu organisatsioonis',
    feat4b: 'Selge vastutus',
    feat4c: 'Auditivalmis aruandlus',
    resultsTitle: 'Tulemused nõukogudele ja juhtidele',
    resultsIntro: 'Outsprinterit kasutavad nõukogud kogevad tavaliselt:',
    res1: 'Parem strateegiline järelevalve',
    res2: 'Kiiremad, kvaliteetsemad otsused',
    res3: 'Vähem üllatusi',
    res4: 'Efektiivsemad nõukogu koosolekud',
    res5: 'Suurenenud usaldus nõukogu ja juhtkonna vahel',
    resultsConclusion: 'Outsprinter tugevdab valitsemist, tehes tulemuslikkuse nähtavaks ja objektiivseks.',
    whyTitle: 'Miks Outsprinter sobib nõukogu tasandi kasutuseks',
    why1: 'Loodud juhtide tähelepanuulatuse jaoks',
    why2: 'Keskendub tulemustele, mitte tegevusele',
    why3: 'Pakub selgust ilma mikromanageerimiseta',
    why4: 'Toetab pikaajalist strateegilist mõtlemist',
    ctaTitle: 'Juhi selgusega. Valitse kindlustundega.',
    ctaBtn1: 'Küsi nõukogu demo',
    ctaBtn2: 'Räägi müügiga',
  },

  // Use Case - Project Management
  ucProject: {
    seoTitle: 'Projektijuhtimine',
    seoDesc: 'Tarni projektid õigeaegselt, mahus ja mõõdetava mõjuga. Joonda projekti täitmine ettevõtte eesmärkidega ja jälgi tarnet tähendusrikaste KPI-de kaudu.',
    badge: 'Projektijuhtimine',
    heroTitle: 'Tarni projektid õigeaegselt, mahus ja mõõdetava mõjuga.',
    heroDesc: 'Projektid ebaõnnestuvad mitte sellepärast, et meeskonnad ei tööta kõvasti — vaid sellepärast, et prioriteedid muutuvad, edenemist ei jälgita selgelt ja tarne kaotab seose äritulemustega. Outsprinter aitab projektimeeskondadel joondada projekti täitmise ettevõtte eesmärkidega, viia läbi fookustatud iganädalasi sprinte ja jälgida tarnet tähendusrikaste KPI-de kaudu.',
    challengeTitle: 'Väljakutse projektijuhtimises',
    challengeIntro: 'Projektimeeskonnad võitlevad tavaliselt:',
    ch1: 'Mahu kasv',
    ch2: 'Ebaselged prioriteedid',
    ch3: 'Edenemisest teatatakse liiga hilja',
    ch4: 'Projektid pole seotud strateegiliste eesmärkidega',
    ch5: 'Meeskonnad töötavad kõvasti teadmata, kas nad võidavad',
    challengeConclusion: 'See viib viivituste, kulude ületamise ja huvigruppide frustratsioonini.',
    howTitle: 'Kuidas Outsprinter parandab projekti täitmist',
    howIntro: 'Outsprinter ühendab projektid tulemustega.',
    howSubIntro: 'Outsprinteriga saavad projektimeeskonnad:',
    how1: 'Defineerida projekti KPI-d seotud äriväärtusega',
    how2: 'Viia läbi struktureeritud iganädalasi sprinte',
    how3: 'Jälgida edenemist reaalajas',
    how4: 'Tuvastada riske varakult',
    how5: 'Hoida huvigrupid joondatuna live töölaudadega',
    howConclusion: 'Täitmine muutub ennustatavaks ja läbipaistvaks.',
    workflowTitle: 'Tüüpiline projekti töövoog Outsprinteris',
    wf1Title: 'Projekti seadistamine',
    wf1a: 'Defineeri projekti eesmärgid ja KPI-d',
    wf1b: 'Joonda projekti KPI-d ettevõtte eesmärkidega',
    wf1c: 'Määra omanikud ja ajakavad',
    wf2Title: 'Iganädalane täitmine',
    wf2a: 'Planeeri iganädalased sprindid',
    wf2b: 'Jälgi ülesannete täitmist',
    wf2c: 'Uuenda KPI-sid',
    wf2d: 'AI toob esile tarneriskid',
    wf3Title: 'Huvigruppide aruandlus',
    wf3a: 'Jaga live töölaudu',
    wf3b: 'Likvideeri käsitsi staatuse aruanded',
    featuresTitle: 'Põhifunktsioonid projektijuhtimisele',
    feat1Title: 'KPI haldur',
    feat1a: 'Projekti KPI mallid',
    feat1b: 'Edenemise ja kvaliteedi jälgimine',
    feat2Title: 'Sprindi haldur',
    feat2a: 'Iganädalane sprindi planeerimine',
    feat2b: 'Mahu kontroll',
    feat2c: 'Tarne jälgimine',
    feat3Title: 'Töölauad',
    feat3a: 'Projekti tervise töölaud',
    feat3b: 'Ajajoone ja edenemise visualiseerimine',
    feat4Title: 'Nutikas AI assistent',
    feat4a: 'Mahu kasvu tuvastamine',
    feat4b: 'Tarneriski analüüs',
    feat4c: 'Iganädalased staatuse kokkuvõtted',
    resultsTitle: 'Tulemused, mida projektimeeskonnad saavutavad',
    resultsIntro: 'Meeskonnad näevad tavaliselt:',
    res1: 'Kõrgemad õigeaegse tarne määrad',
    res2: 'Vähem viimase hetke üllatusi',
    res3: 'Selge vastutus',
    res4: 'Parem huvigruppide kommunikatsioon',
    res5: 'Tugevam seos projektide ja strateegia vahel',
    resultsConclusion: 'Outsprinter aitab projektidel pakkuda tegelikku äriväärtust.',
    whyTitle: 'Miks Outsprinter töötab projektimeeskondadele',
    why1: 'Tulemusele suunatud, mitte ülesanderaske',
    why2: 'Kerge ja kiiresti omaksvõetav',
    why3: 'Töötab mitme projekti üleselt',
    why4: 'Selge juhtkonna nähtavus',
    ctaTitle: 'Tarni projekte kindlustundega.',
  },

  // Use Case - Public Institutions
  ucPublic: {
    seoTitle: 'Avalik sektor',
    seoDesc: 'Läbipaistvus, vastutus ja mõõdetav mõju avalikule sektorile. Jälgi tulemuslikkust järjepidevalt ja demonstreeri mõju andmepõhise selgusega.',
    badge: 'Avalik sektor',
    heroTitle: 'Läbipaistvus, vastutus ja mõõdetav mõju avalikule sektorile.',
    heroDesc: 'Avaliku sektori asutused tegutsevad kõrgete ootustega vastutuse, läbipaistvuse ja tulemuste osas — sageli piiratud ressursside ja keeruliste valitsemisstruktuuridega. Outsprinter aitab avaliku sektori organisatsioonidel defineerida selged eesmärgid, jälgida tulemuslikkust järjepidevalt ja demonstreerida mõju andmepõhise selgusega.',
    challengeTitle: 'Väljakutse avalikele asutustele',
    challengeIntro: 'Avalikud organisatsioonid seisavad sageli silmitsi:',
    ch1: 'Ebaselged või raskesti mõõdetavad eesmärgid',
    ch2: 'Killustatud aruandlus osakondade vahel',
    ch3: 'Piiratud reaalajas nähtavus tulemuslikkusesse',
    ch4: 'Käsitsi, aeganõudvad aruandlusprotsessid',
    ch5: 'Kõrged vastutusnõuded madala veatolerantsiga',
    challengeConclusion: 'See teeb efektiivse juhtimise raskeks.',
    howTitle: 'Kuidas Outsprinter toetab avaliku sektori täitmist',
    howIntro: 'Outsprinter toob struktuuri, selguse ja läbipaistvuse avalikesse asutustesse.',
    howSubIntro: 'Outsprinteriga saavad avalikud organisatsioonid:',
    how1: 'Defineerida mõõdetavad KPI-d joondatud poliitikaeesmärkidega',
    how2: 'Jälgida edenemist iganädalaselt kvartaalse asemel',
    how3: 'Parandada osakondade vahelist koordinatsiooni',
    how4: 'Pakkuda juhtkonnale ja huvigruppidele selgeid töölaudu',
    how5: 'Suurendada usaldust läbipaistva aruandluse kaudu',
    howConclusion: 'Täitmine muutub mõõdetavaks ja kaitstavaks.',
    workflowTitle: 'Tüüpiline avaliku sektori töövoog Outsprinteris',
    wf1Title: 'Seadistamine',
    wf1a: 'Defineeri strateegilised eesmärgid ja KPI-d',
    wf1b: 'Joonda osakondade KPI-d',
    wf1c: 'Määra selge vastutus',
    wf2Title: 'Pidev haldus',
    wf2a: 'Osakonnad uuendavad KPI-sid iganädalaselt',
    wf2b: 'Töölauad peegeldavad reaalajas edenemist',
    wf2c: 'AI märgistab viivitused ja riskid',
    wf3Title: 'Aruandlus',
    wf3a: 'Jaga töölaudu juhtkonna ja järelevalveorganitega',
    wf3b: 'Ekspordi aruanded auditite ja ülevaatuste jaoks',
    featuresTitle: 'Põhifunktsioonid avalikele asutustele',
    feat1Title: 'KPI haldur',
    feat1a: 'Poliitika ja teenuse KPI-d',
    feat1b: 'Tulemusepõhine jälgimine',
    feat2Title: 'Töölauad',
    feat2a: 'Osakonna tasandi läbipaistvus',
    feat2b: 'Programmi tulemuslikkuse ülevaated',
    feat3Title: 'Nutikas AI assistent',
    feat3a: 'Riski ja viivituse tuvastamine',
    feat3b: 'Tulemuslikkuse kokkuvõtted',
    feat4Title: 'Vastavus ja valitsemine',
    feat4a: 'Auditilogid',
    feat4b: 'Rollipõhine ligipääs',
    feat4c: 'Andmete eksport',
    resultsTitle: 'Tulemused, mida avalikud asutused saavutavad',
    resultsIntro: 'Asutused kogevad tavaliselt:',
    res1: 'Suurem läbipaistvus',
    res2: 'Parem vastutus',
    res3: 'Kiirem reageerimine probleemidele',
    res4: 'Paranenud usaldus huvigruppidega',
    res5: 'Selge mõju demonstreerimine',
    resultsConclusion: 'Outsprinter aitab avalikel organisatsioonidel tõestada väärtust — selgelt ja usutavalt.',
    whyTitle: 'Miks Outsprinter sobib avalikule sektorile',
    why1: 'Loodud läbipaistvuse jaoks',
    why2: 'Lihtne ja struktureeritud',
    why3: 'Turvaline ja vastav',
    why4: 'Skaleerub osakondade üleselt',
    ctaTitle: 'Too selgus ja vastutus avalikku teenistusse.',
    ctaBtn1: 'Küsi demo',
    ctaBtn2: 'Võta ühendust müügiga',
  },

  // Use Case - Nonprofits
  ucNonprofit: {
    seoTitle: 'Mittetulundusühingud',
    seoDesc: 'Maksimeeri mõju. Tugevda vastutust. Tõesta tulemusi. Defineeri selged eesmärgid, jälgi tähendusrikkaid KPI-sid ja joonda meeskonnad tulemuste ümber, mis tegelikult loevad.',
    badge: 'Mittetulundusühingud',
    heroTitle: 'Maksimeeri mõju. Tugevda vastutust. Tõesta tulemusi.',
    heroDesc: 'Mittetulundusühingud tegutsevad tugevate missioonide, piiratud ressursside ja kõrgete läbipaistvuse ootustega. Siiski on mõju sageli raske mõõta, kommunikeerida ja järjepidevalt parandada. Outsprinter aitab mittetulundusühingutel defineerida selged eesmärgid, jälgida tähendusrikkaid KPI-sid ja joondada meeskonnad tulemuste ümber, mis tegelikult loevad — ilma halduskoormust lisamata.',
    challengeTitle: 'Väljakutse mittetulundusühingutele',
    challengeIntro: 'Mittetulundusorganisatsioonid seisavad sageli silmitsi:',
    ch1: 'Mõju, mida on raske objektiivselt mõõta',
    ch2: 'Rahastajad ja huvigrupid küsivad selgeid tulemusi',
    ch3: 'Meeskonnad laiali programmide ja algatuste vahel',
    ch4: 'Käsitsi aruandlus kulutab väärtuslikku aega',
    ch5: 'Piiratud nähtavus sellesse, mis tegelikult töötab',
    challengeConclusion: 'See teeb mõju skaleerimise keeruliseks.',
    howTitle: 'Kuidas Outsprinter aitab mittetulundusühingutel pakkuda rohkem mõju',
    howIntro: 'Outsprinter pakub lihtsat täitmise ja mõõtmise süsteemi missioonipõhiseks tööks.',
    howSubIntro: 'Outsprinteriga saavad mittetulundusühingud:',
    how1: 'Defineerida tulemusepõhised KPI-d joondatud nende missiooniga',
    how2: 'Jälgida programmi tulemuslikkust iganädalaselt',
    how3: 'Joondada meeskonnad ja vabatahtlikud prioriteetide ümber',
    how4: 'Pakkuda läbipaistvat aruandlust rahastajatele ja nõukogudele',
    how5: 'Keskenduda rohkem aega mõjule, vähem haldusele',
    howConclusion: 'Missiooni täitmine muutub nähtavaks ja mõõdetavaks.',
    workflowTitle: 'Tüüpiline mittetulundusühingu töövoog Outsprinteris',
    wf1Title: 'Seadistamine',
    wf1a: 'Defineeri strateegilised eesmärgid (missiooni tulemused, ulatus, efektiivsus)',
    wf1b: 'Loo programmi tasandi KPI-d',
    wf1c: 'Määra omandiõigus meeskondadele või programmijuhtidele',
    wf2Title: 'Iganädalane rütm',
    wf2a: 'Uuenda KPI-sid iganädalaselt',
    wf2b: 'Vaata töölauad üle',
    wf2c: 'Planeeri fookustatud parandussprindid',
    wf2d: 'AI toob esile riskid või langeva mõju',
    wf3Title: 'Aruandlus',
    wf3a: 'Jaga töölaudu nõukogude ja rahastajatega',
    wf3b: 'Ekspordi aruanded rahastamise ülevaatusteks',
    featuresTitle: 'Põhifunktsioonid mittetulundusühingutele',
    feat1Title: 'KPI haldur',
    feat1a: 'Missiooni ja mõju KPI-d',
    feat1b: 'Programmi tasandi jälgimine',
    feat2Title: 'Töölauad',
    feat2a: 'Organisatsiooniülene mõju ülevaade',
    feat2b: 'Programmi tulemuslikkuse töölauad',
    feat3Title: 'Nutikas AI assistent',
    feat3a: 'Mõju trendi analüüs',
    feat3b: 'Programmi efektiivsuse ülevaated',
    feat4Title: 'Läbipaistvus ja valitsemine',
    feat4a: 'Selge vastutus',
    feat4b: 'Auditivalmis aruandlus',
    feat4c: 'Rollipõhine ligipääs',
    resultsTitle: 'Tulemused, mida mittetulundusühingud saavutavad',
    resultsIntro: 'Mittetulundusühingud, kes kasutavad Outsprinterit, näevad tavaliselt:',
    res1: 'Selgem mõju demonstreerimine',
    res2: 'Tugevam vastutus programmide üleselt',
    res3: 'Parem nõukogu ja rahastaja kindlustunne',
    res4: 'Paranenud fookus suure mõjuga algatustele',
    res5: 'Vähenenud aruandluse halduskoormus',
    resultsConclusion: 'Outsprinter aitab mittetulundusühingutel muuta kavatsuse mõõdetavaks mõjuks.',
    whyTitle: 'Miks Outsprinter sobib mittetulundusühingutele',
    why1: 'Tulemusele suunatud, mitte kasumile suunatud',
    why2: 'Lihtne ja kergesti omaksvõetav',
    why3: 'Toetab läbipaistvust ja usaldust',
    why4: 'Taskukohane ja skaleeritav',
    ctaTitle: 'Paku rohkem mõju selgusega.',
    ctaBtn2: 'Küsi demo',
  },

  // Use Case - HR Teams
  ucHR: {
    seoTitle: 'Personaliosakonnad',
    seoDesc: 'Joonda inimesed, tulemuslikkus ja strateegia — selguse ja andmetega. Muuda personalistrateegia mõõdetavaks täitmiseks, mis on joondatud ettevõtte eesmärkidega.',
    badge: 'Personaliosakonnad',
    heroTitle: 'Joonda inimesed, tulemuslikkus ja strateegia — selguse ja andmetega.',
    heroDesc: 'Personaliosakonnad mängivad kriitilist rolli ettevõtte edus, kuid nende mõju on sageli raske mõõta. Eesmärke nagu pühendumus, tulemuslikkus ja areng arutatakse — kuid mitte alati ei jälgita struktureeritud, tulemusele suunatud viisil. Outsprinter aitab personaliosakondadel muuta personalistrateegia mõõdetavaks täitmiseks, mis on joondatud ettevõtte eesmärkide ja juhtkonna ootustega.',
    challengeTitle: 'Väljakutse personaliosakondadele',
    challengeIntro: 'HR ja People Ops meeskonnad seisavad sageli silmitsi:',
    ch1: 'Pehmed eesmärgid, mida on raske kvantifitseerida',
    ch2: 'Ühendamata personali algatused',
    ch3: 'Piiratud nähtavus meeskonna tulemuslikkuse tervisesse',
    ch4: 'Käsitsi aruandlus juhtkonnale ja nõukogudele',
    ch5: 'Raskused HR pingutuste sidumisel äritulemustega',
    challengeConclusion: 'See vähendab HR strateegilist mõju.',
    howTitle: 'Kuidas Outsprinter tõstab HR täitmist',
    howIntro: 'Outsprinter annab personaliosakondadele struktureeritud täitmise ja mõõtmise süsteemi.',
    howSubIntro: 'Outsprinteriga saavad personaliosakonnad:',
    how1: 'Defineerida selged inimestega seotud KPI-d',
    how2: 'Joondada HR algatused ettevõtte strateegiaga',
    how3: 'Jälgida edenemist iganädalaselt kvartaalse asemel',
    how4: 'Pakkuda juhtkonnale läbipaistvaid töölaudu',
    how5: 'Tuvastada riske varakult (pühendumus, voolavus, maht)',
    howConclusion: 'HR muutub proaktiivseks, andmepõhiseks ja strateegiliseks.',
    workflowTitle: 'Tüüpiline HR töövoog Outsprinteris',
    wf1Title: 'Seadistamine',
    wf1a: 'Defineeri HR KPI-d (pühendumus, püsivus, värbamiskiirus, sisseelamise edukus, tulemusvestlused)',
    wf1b: 'Joonda KPI-d ettevõtte eesmärkidega',
    wf1c: 'Määra omandiõigus',
    wf2Title: 'Iganädalane ja igakuine rütm',
    wf2a: 'Uuenda KPI-sid regulaarselt',
    wf2b: 'Jälgi algatusi sprintide kaudu',
    wf2c: 'AI toob esile trendid ja riskid',
    wf3Title: 'Juhtkonna aruandlus',
    wf3a: 'Jaga HR töölaudu juhtidega',
    wf3b: 'Toeta otsuseid reaalajas andmetega',
    featuresTitle: 'Põhifunktsioonid personaliosakondadele',
    feat1Title: 'KPI haldur',
    feat1a: 'Inimeste ja kultuuri KPI mallid',
    feat1b: 'Trendi ja künnise jälgimine',
    feat2Title: 'Sprindi haldur',
    feat2a: 'HR algatuste planeerimine',
    feat2b: 'Värbamise ja sisseelamise sprindid',
    feat2c: 'Tulemusvestluste tsüklid',
    feat3Title: 'Töölauad',
    feat3a: 'Pühendumuse ja püsivuse töölauad',
    feat3b: 'Värbamistoru ülevaade',
    feat3c: 'Meeskonna tervise indikaatorid',
    feat4Title: 'Nutikas AI assistent',
    feat4a: 'Lahkumisriski signaalid',
    feat4b: 'Pühendumuse trendi analüüs',
    feat4c: 'Soovitused personali algatusteks',
    resultsTitle: 'Tulemused, mida personaliosakonnad saavutavad',
    resultsIntro: 'Personaliosakonnad, kes kasutavad Outsprinterit, saavutavad tavaliselt:',
    res1: 'Tugevam joondatus juhtkonnaga',
    res2: 'Selge nähtavus inimeste tulemuslikkusesse',
    res3: 'Püsivusriskide varasem tuvastamine',
    res4: 'Efektiivsemad HR algatused',
    res5: 'Suurenenud strateegiline usaldusväärsus',
    resultsConclusion: 'Outsprinter aitab HR-il liikuda tugifunktsioonist strateegiliseks partneriks.',
    whyTitle: 'Miks Outsprinter töötab HR jaoks',
    why1: 'Tulemusele suunatud, mitte ainult tegevuspõhine',
    why2: 'Läbipaistev ja juhtkonnasõbralik',
    why3: 'Lihtne omaks võtta kogu organisatsioonis',
    why4: 'Seob inimeste mõõdikud ärieesmärkidega',
    ctaTitle: 'Muuda personalistrateegia mõõdetavaks mõjuks.',
  },

  // Use Case - Manufacturing
  ucManuf: {
    seoTitle: 'Tootmine ja tööstus',
    seoDesc: 'Muuda tootmisandmed ennustatavaks tulemuslikkuseks ja pidevaks parandamiseks. Jälgi OEE-d, läbilaskevõimet, kvaliteeti ja tarnet reaalajas nähtavusega.',
    badge: 'Tootmine ja tööstus',
    heroTitle: 'Muuda tootmisandmed ennustatavaks tulemuslikkuseks ja pidevaks parandamiseks.',
    heroDesc: 'Tootmisettevõtted tegutsevad keerulistes keskkondades, kus efektiivsus, kvaliteet, kulukontroll ja tarne usaldusväärsus peavad iga päev koostööd tegema. Kui KPI-sid vaadatakse üle liiga hilja või täitmine pole joondatud, muutuvad väikesed probleemid kiiresti kulukateks probleemideks. Outsprinter aitab tootmisorganisatsioonidel hallata tootmise tulemuslikkust selguse, distsipliini ja reaalajas nähtavusega.',
    challengeTitle: 'Väljakutse tootmisettevõtetele',
    challengeIntro: 'Tootmismeeskonnad võitlevad sageli:',
    ch1: 'KPI-sid jälgitakse eraldi süsteemides või tabelites',
    ch2: 'Tulemuslikkuse probleemid avastatakse liiga hilja',
    ch3: 'Piiratud nähtavus vahetuste, liinide või tehaste üleselt',
    ch4: 'Liiga palju mõõdikuid ilma selgete prioriteetideta',
    ch5: 'Reaktiivne tulekahjude kustutamine pideva parandamise asemel',
    challengeConclusion: 'See viib seisakute, kvaliteediprobleemide, täitmata tarnemärkide ja tõusvate kuludeni.',
    howTitle: 'Kuidas Outsprinter parandab tootmise täitmist',
    howIntro: 'Outsprinter toob struktuuri ja läbipaistvuse tootmise tulemuslikkusesse. Outsprinteriga saavad tootmisettevõtted:',
    how1: 'Defineerida selged tootmise KPI-d joondatud ärieesmärkidega',
    how2: 'Jälgida tulemuslikkust iganädalaselt trendi nähtavusega',
    how3: 'Joondada tootmise, hoolduse, kvaliteedi ja operatsioonide meeskonnad',
    how4: 'Tuvastada pudelikaelad ja riskid varakult',
    how5: 'Toetada pidevat parandamist andmetega',
    howConclusion: 'Täitmine muutub proaktiivseks, mõõdetavaks ja järjepidevaks.',
    workflowTitle: 'Tüüpiline tootmise töövoog Outsprinteris',
    wf1Title: 'Seadistamine',
    wf1a: 'Defineeri tootmise KPI-d (OEE, läbilaskevõime, praagimäär, seisakuaeg, tarneae, õigeaegne tarne)',
    wf1b: 'Joonda KPI-d ettevõtte tasandi eesmärkidega',
    wf1c: 'Määra selge omandiõigus KPI kohta',
    wf2Title: 'Iganädalane rütm',
    wf2a: 'Uuenda KPI-sid iganädalaselt',
    wf2b: 'Vaata tootmise töölauad üle',
    wf2c: 'Planeeri parandussprindid (protsess, kvaliteet, hooldus)',
    wf2d: 'AI toob esile negatiivsed trendid ja anomaaliad',
    wf3Title: 'Juhtkonna ülevaade',
    wf3a: 'Juhtkond vaatab tehase ja liini tulemuslikkust',
    wf3b: 'Fookus punastele ja kollastele KPI-dele',
    wf3c: 'Otsused tehakse faktide, mitte oletuste põhjal',
    featuresTitle: 'Põhifunktsioonid tootmisele ja tööstusele',
    feat1Title: 'KPI haldur',
    feat1a: 'Tootmise KPI mallid',
    feat1b: 'Trendide analüüs nädalate ja kuude lõikes',
    feat1c: 'Künnisepõhised hoiatused',
    feat2Title: 'Sprindi haldur',
    feat2a: 'Pideva parandamise sprindid',
    feat2b: 'Hoolduse ja protsessi optimeerimise jälgimine',
    feat2c: 'Selge omandiõigus ja vastutus',
    feat3Title: 'Töölauad',
    feat3a: 'Tehase tasandi tulemuslikkuse töölauad',
    feat3b: 'Liini ja protsessi ülevaade',
    feat3c: 'Efektiivsuse ja kvaliteedi soojuskaardid',
    feat4Title: 'Nutikas AI assistent',
    feat4a: 'Pudelikaela ja seisaku mustri tuvastamine',
    feat4b: 'Kvaliteedi kõrvalekalde hoiatused',
    feat4c: 'Ennustavad riskiülevaated',
    resultsTitle: 'Tulemused, mida tootmisettevõtted saavutavad',
    resultsIntro: 'Tootmisorganisatsioonid, kes kasutavad Outsprinterit, näevad tavaliselt:',
    res1: 'Paranenud tootmise efektiivsus',
    res2: 'Vähenenud seisakuaeg ja raiskamine',
    res3: 'Parem õigeaegne tarne',
    res4: 'Kiirem probleemide tuvastamine',
    res5: 'Tugevam meeskondadeülene joondatus',
    resultsConclusion: 'Outsprinter aitab tootmismeeskondadel liikuda reaktiivselt probleemide lahendamiselt struktureeritud parandamisele.',
    whyTitle: 'Miks Outsprinter sobib tootmiskeskkondadesse',
    why1: 'KPI-põhine, täitmisele suunatud lähenemine',
    why2: 'Lihtne iganädalane rütm, mis sobib tootmise reaalsusega',
    why3: 'Selge nähtavus meeskondade ja vahetuste üleselt',
    why4: 'Skaleerub ühest tehasest mitme saidiga operatsioonideni',
    ctaTitle: 'Juhi tootmist selguse ja kontrolliga.',
  },

  // Blog Post UI
  blogPost: {
    home: 'Avaleht',
    backToBlog: 'Tagasi blogisse',
    linkCopied: 'Link kopeeritud!',
    linkCopiedDesc: 'Artikli link on kopeeritud lõikelauale.',
    topicsCovered: 'Teemad:',
    shareArticle: 'Jaga seda artiklit:',
    aboutAuthor: 'Autorist {{name}}',
    authorBio: 'Ettevõtja, äriingel ja Outsprinteri asutaja. Pühendunud skaleeritavate ettevõtete ehitamisele selge täitmise ja mõõdetavate tulemustega.',
    connectLinkedIn: 'Ühenda LinkedInis',
    relatedArticles: 'Seotud artiklid',
    ctaTitle: 'Alusta KPI-de jälgimist õigesti',
    ctaDesc: 'Rakenda need teadmised praktikasse Outsprinteriga. Iganädalane jälgimine, visuaalsed töölauad ja selge vastutus.',
    ctaBtn: 'Alusta tasuta prooviperioodi',
    allRights: 'Kõik õigused kaitstud.',
  },

  cookies: {
    message: 'Kasutame küpsiseid ja analüütikat, et parandada teie kasutuskogemust. Nõustudes lubate meil koguda anonüümseid kasutusandmeid Google Analyticsi kaudu.',
    learnMore: 'Loe lähemalt',
    decline: 'Keeldu',
    accept: 'Nõustu',
  },
};

export default et;
